import {
  BankOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  DeleteOutlined,
  EnvironmentOutlined,
  FilePdfOutlined,
  FolderAddOutlined,
  MoneyCollectOutlined,
  OrderedListOutlined,
  PhoneOutlined,
  PrinterOutlined,
  QrcodeOutlined,
  ReloadOutlined,
  SaveOutlined,
  TagOutlined,
  UserOutlined,
  PlusOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Input,
  message,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import html2pdf from "html2pdf.js";
import { QRCodeCanvas } from "qrcode.react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CREATE_jwel } from "../../../Config/Config";
import DashboardTableHeaderStyles from "../../Pages/DashboardTableHeaderStyles";
import { BillPdfDownload } from "./BillPdfDownload";
import EditItemDetails from "./EditItemDetails";
import HoldSelectDialog from "./HoldSelectDialog";
import HomeBillDialog from "./HomeBillDialog";
import { printReceipt } from "./eposPrint";
import CustomerBillInfoDialog from "./CustomerBillInfo";
import QrCodeDialog from "./QrCodeDialog";
import DirectPrint from "./DirectPrint";
import EstimationSelectDialog from "../SalesInvoice/EstimationSelectDialog";
import ItemDetailsPopover from "../SalesInvoice/ItemDetailsPopover";
import PaymentModesDialog from "../SalesInvoice/PaymentModes";
import CustomerDialog from "../SalesInvoice/CustomerDialog";
import CustomerSelectDialog from "../SalesInvoice/CustomerSelectDialog";

const { Option } = Select;

const SalesInvoiceReturn = () => {
  const receiptRef = useRef(null);
  const samplePrintRef = useRef(null);
  const jewelRef = useRef(null);
  const tagNoRef = useRef(null);
  const submitRef = useRef(null);
  const estNoRef = useRef(null);
  const fetchRef = useRef(null);
  const mobileRef = useRef(null);
  const searchRef = useRef(null);
  const smCodeRef = useRef(null);
  const smSubmitRef = useRef(null);
  const qrRef = useRef(null);
  const navigate = useNavigate();
  const [cardAcc, setCardAcc] = useState("");
  const [upiAcc, setUpiAcc] = useState("");
  const [onlineAcc, setOnlineAcc] = useState("");
  const [gstData, setGstData] = useState([]);
  const [totalGstData, setTotalGstData] = useState([]);
  const [barCodeData, setBarCodeData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const [designData, setDesignData] = useState([]);
  const [totalBasicAmount, setTotalBasicAmount] = useState(0);
  const [totalGstAmt, setTotalGstAmt] = useState(0);
  const [totalCGSTAmt, setTotalCGSTAmt] = useState(0);
  const [totalSGSTAmt, setTotalSGSTAmt] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiSAmt, steTotalDisAmt] = useState(0);
  const [totalGrossAmount, setTotalGrossAmount] = useState(0);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [disPer, setDisPer] = useState(0);
  const [totalDiscountAmt, setTotalDiscountAmt] = useState(0);
  const [totalAdjust, setTotalAdjust] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [smCode, setSmCode] = useState("");
  const [smCodeData, setSmCodeData] = useState([]);
  const [cashValue, setCashValue] = useState("CASH");
  const [cashAmt, setCashAmt] = useState(0);
  const [cardAmt, setCardAmt] = useState(0);
  const [upiAmt, setUpiAmt] = useState(0);
  const [onlineAmt, setOnlineAmt] = useState(0);
  const [creditAmt, setCreditAmt] = useState(0);
  const [userArea, setUserArea] = useState();
  const [userName, setUserName] = useState();
  const [singleImage, setSingleImage] = useState();
  const [gstNo, setGstNo] = useState("");
  const [gstValue, setGstValue] = useState();
  const [userPhone, setUserPhone] = useState("");
  const [conditions, setConditions] = useState("");
  const [ins, setIns] = useState("");
  const [ins1, setIns1] = useState("");
  const [ins2, setIns2] = useState("");
  const [ins3, setIns3] = useState("");
  const [ins4, setIns4] = useState("");
  const [ins5, setIns5] = useState("");
  const [ins6, setIns6] = useState("");
  const [address, setAddress] = useState("");
  const [address1, setAddress1] = useState("");
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [tagNo, setTagNo] = useState();
  const [estNo, setEstNo] = useState();
  const [selectJewelType, setSelectJewelType] = useState("RETAIL");
  const [billNo, setBillNo] = useState();
  const [billDate, setBillDate] = useState();
  const [hNo, setHNo] = useState();
  const [invNo, setInvNo] = useState();
  const [holdNo, setHoldNo] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const [visibleHis, setVisibleHis] = useState(false);
  const [payMode, setPayMode] = useState(false);
  const [rotating, setRotating] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [phoneNo, setPhoneNo] = useState();
  const [cPhoneNo, setCPhoneNo] = useState();
  const [open, setOpen] = useState(false);
  const [customerSelectOpen, setCustomerSelectOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchHoldText, setSearchHoldText] = useState("");
  const [itemDetailsOpen, setItemDetailsOpen] = useState(false);
  const [itemDetailsData, setItemDetailsData] = useState({});
  const [itemDesignCode, setItemDEsignCode] = useState();
  const [base64QR, setBase64QR] = useState("");
  const [base64, setBase64] = useState();
  const [base64Images, setBase64Images] = useState();
  const [prvBalance, setPrvBalance] = useState(0);
  const [holdOpen, setHoldOpen] = useState(false);
  const [holdData, setHoldData] = useState([]);
  const [filteredHoldData, setFilteredHoldData] = useState([]);
  const [selectedHoldRowKeys, setSelectedHoldRowKeys] = useState([]);
  const [homeDetailsOpen, setHomeDetailsOpen] = useState(false);
  const [productData, setProductData] = useState([]);
  const [qty, setQty] = useState(0);
  const [amount, setAmount] = useState(0);
  const [disCount, setDisCount] = useState(0);
  const [rate, setRate] = useState(0);
  const [disAmt, setDisAmt] = useState(0);
  const [productName, setProductName] = useState("");
  const [designCode, setDesignCode] = useState("");
  const [pTypeName, setPTypeName] = useState("");
  const [brandName, setBrandName] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [qtyData, setQtyData] = useState([]);
  const [mobile, setMobile] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [comm, setComm] = useState(0);
  const [qrCodeOpen, setQrCodeOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [printSaving, setPrintSaving] = useState(false);
  const [thermalPrinter, setThermalPrinter] = useState("");
  const [thermalPrinterDetails, setThermalPrinterDetails] = useState({});
  const [formValues, setFormValues] = useState({
    mobile1: "",
    city: "",
    name: "",
    mobile2: "",
    phone: "",
    address1: "",
    address2: "",
    address3: "",
    address4: "",
    state: "ANDHRA PRADESH",
    stateCode: "37",
    gstin: "",
    panNo: "",
    idProof: "",
    dob: "",
    anniversary: "",
    locationType: "LOCAL",
  });
  const logoImage = localStorage.getItem("singleImage");
  const pdfModule = localStorage.getItem("pdfModule");
  const localIp = localStorage.getItem("ipAddress");
  const tenantName = localStorage.getItem("tenantName");
  const loginName = localStorage.getItem("loginName");
  const upiId = localStorage.getItem("upiId");
  const adminType = localStorage.getItem("adminType");
  const totalAmt = totalNetAmount - cardAmt - upiAmt - onlineAmt - creditAmt;
  const invPaidAmt = totalNetAmount - creditAmt;

  const isValidValue = (val) => {
    return (
      val !== null &&
      val !== undefined &&
      val !== "-" &&
      String(val).trim() !== "" &&
      String(val) !== "undefined"
    );
  };

  const upiLink = `upi://pay?pa=${upiId}&am=${upiAmt}&cu=INR`;

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const totalBalance = prvBalance + creditAmt;

  const invNoAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetMaxNumberInTable?tableName=RETURN_MAST&column=BILLNO`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        const rawValue = data[0]?.Column1;
        const maxInvNo = Number.isFinite(Number(rawValue))
          ? Number(rawValue)
          : 0;
        const newInvNo = maxInvNo + 1;
        setInvNo(newInvNo);
        return newInvNo;
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const holdNoAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetMaxNumberInTable?tableName=CREDIT_BILLMAST_HOLD&column=BILLNO`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        const rawValue = data[0]?.Column1;
        const maxInvNo = Number.isFinite(Number(rawValue))
          ? Number(rawValue)
          : 0;
        const newInvNo = maxInvNo + 1;
        setHoldNo(newInvNo);
        return newInvNo;
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const onlineAccNoAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=ONLINEMODE_MAST`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        const card = data.find((item) => item.PTYPE === "CARD");
        const upi = data.find((item) => item.PTYPE === "UPI");
        const online = data.find((item) => item.PTYPE === "ONLINE");
        if (card) setCardAcc(card.accno);
        if (upi) setUpiAcc(upi.accno);
        if (online) setOnlineAcc(online.accno);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const gstCheckAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=PURCHASE_TYPE`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setGstData(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const userAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setUserName(data[0]?.FIRMNAME);
        setUserArea(data[0]?.CITY);
        setSingleImage(data[0]?.EPASS2);
        setGstNo(data[0]?.TINNO);
        setGstValue(data[0]?.GST);
        setUserPhone(data[0]?.MOBILE);
        setConditions(data[0]?.INSTTITLE);
        setIns(data[0]?.INST1);
        setIns1(data[0]?.INST2);
        setIns2(data[0]?.INST3);
        setIns3(data[0]?.INST4);
        setIns4(data[0]?.INST5);
        setIns5(data[0]?.INST6);
        setIns6(data[0]?.INST7);
        setAddress(data[0]?.ADD1);
        setAddress1(data[0]?.ADD2);
        setCity(data[0]?.CITY);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const userGetDetailsAPI = async (value) => {
    const mobileValue = isValidValue(value) ? value : phoneNo;
    if (!isValidValue(mobileValue)) return;
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=MOBILENO='${value ? value : phoneNo
        }'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setUserDetails(data[0]);
        setFormValues({
          mobile1: data[0]?.Mobileno || "",
          city: data[0]?.Area || "",
          name: data[0]?.Custname || "",
          mobile2: data[0]?.Phoneno || "",
          phone: data[0]?.Phoneno || "",
          address1: data[0]?.add1 || "",
          address2: data[0]?.add2 || "",
          address3: data[0]?.add3 || "",
          address4: data[0]?.add4 || "",
          state: data[0]?.STATE || "ANDHRA PRADESH",
          stateCode: data[0]?.STATECODE || "37",
          gstin: data[0]?.TINNO || "-",
          panNo: "",
          idProof: "",
          dob: data[0]?.dob || "",
          anniversary: data[0]?.ANNVERSARY || "",
          locationType: data[0]?.STATION || "LOCAL",
        });
        setPhoneNo();
        smCodeRef.current?.focus();
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const userDetailsAPI = async (value) => {
    const mobileValue = isValidValue(value) ? value : phoneNo;
    if (!isValidValue(mobileValue)) return;
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=MOBILENO='${value ? value : phoneNo
        }'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setUserDetails(data[0]);
        setCPhoneNo(data[0]?.Mobileno);
        OpeningLedgerBalanceAPI(data[0]?.Mobileno, data[0]?.Custname);
        setFormValues({
          mobile1: data[0]?.Mobileno || "",
          city: data[0]?.Area || "",
          name: data[0]?.Custname || "",
          mobile2: data[0]?.Phoneno || "",
          phone: data[0]?.Phoneno || "",
          address1: data[0]?.add1 || "",
          address2: data[0]?.add2 || "",
          address3: data[0]?.add3 || "",
          address4: data[0]?.add4 || "",
          state: data[0]?.STATE || "ANDHRA PRADESH",
          stateCode: data[0]?.STATECODE || "37",
          gstin: data[0]?.TINNO || "-",
          panNo: "",
          idProof: "",
          dob: data[0]?.dob || "",
          anniversary: data[0]?.ANNVERSARY || "",
          locationType: data[0]?.STATION || "LOCAL",
        });
        setPhoneNo();
        smCodeRef.current?.focus();
      } else {
        setOpen(true);
        setUserDetails({});
        setFormValues({
          mobile1: phoneNo,
          city: "",
          name: "",
          mobile2: "",
          phone: "",
          address1: "",
          address2: "",
          address3: "",
          address4: "",
          state: "ANDHRA PRADESH",
          stateCode: "37",
          gstin: "",
          panNo: "",
          idProof: "",
          dob: "",
          anniversary: "",
          locationType: "LOCAL",
        });
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const openNewCustomer = () => {
    setFormValues({
      mobile1: "",
      city: "",
      name: "",
      mobile2: "",
      phone: "",
      address1: "",
      address2: "",
      address3: "",
      address4: "",
      state: "ANDHRA PRADESH",
      stateCode: "37",
      gstin: "",
      panNo: "",
      idProof: "",
      dob: "",
      anniversary: "",
      locationType: "LOCAL",
    });
    setOpen(true);
  };

  const handleCustomerSelect = (customer) => {
    setCustomerSelectOpen(false);
    setUserDetails(customer);
    setCPhoneNo(customer.Mobileno);
    OpeningLedgerBalanceAPI(customer.Mobileno, customer.Custname);
    setFormValues({
      mobile1: customer.Mobileno || "",
      city: customer.Area || "",
      name: customer.Custname || "",
      mobile2: customer.Phoneno || "",
      phone: customer.Phoneno || "",
      address1: customer.add1 || "",
      address2: customer.add2 || "",
      address3: customer.add3 || "",
      address4: customer.add4 || "",
      state: customer.STATE || "ANDHRA PRADESH",
      stateCode: customer.STATECODE || "37",
      gstin: customer.TINNO || "-",
      panNo: "",
      idProof: "",
      dob: customer.dob || "",
      anniversary: customer.ANNVERSARY || "",
      locationType: customer.STATION || "LOCAL",
    });
    setTimeout(() => smCodeRef.current?.focus(), 300);
  };

  const smCodeAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=BOYMAST&where=CODE='${smCode}'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      setSmCodeData(data);
      if (!Array.isArray(data) || data.length === 0) {
        setSmCode("");
        message.open({
          type: "error",
          content: <div style={{ fontSize: "20px" }}>Sm Code Not existed</div>,
        });
        return;
      } else {
        tagNoRef.current?.focus();
        message.open({
          type: "success",
          content: (
            <div style={{ fontSize: "20px" }}>
              Sm Code existed{" "}
              <span style={{ color: "red", fontWeight: "bold" }}>
                {data[0]?.NAME}
              </span>
            </div>
          ),
        });
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const qtyAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CURRENT_STOCK&where=DESIGNCODE='${no}'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      setQtyData((prev) => {
        const filteredNewItems = data
          .filter(
            (item) =>
              !prev.some((prevItem) => prevItem.DesignCode === item.DesignCode),
          )
          .map((item) => ({ DesignCode: item.DesignCode, Qty: item.Qty }));
        return [...prev, ...filteredNewItems];
      });
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const commissionAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=CONFIGURE`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setComm(data[0]?.COMM);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const mainAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CURRENT_STOCK&where=DESIGNCODE='${tagNo}'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      setDesignData(data);
      if (!Array.isArray(data) || data.length === 0) {
        message.open({
          type: "error",
          content: (
            <div style={{ fontSize: "20px" }}>Design Code Not existed</div>
          ),
        });
        return;
      }

      setTagNo();
      setBarCodeData((prevData) => {
        let updatedData = [...prevData];

        data.forEach((newItem) => {
          const gstItem = gstData.find((gst) => gst.PType === newItem.PTYPE);
          let appliedGST = 0;
          if (gstItem?.ALLOWGSTVALUE === true) {
            const offerAmount = newItem.offer ?? 0;
            if (offerAmount <= gstItem.BELLOWVALUE) {
              appliedGST = gstItem.BELLOWPER;
            } else if (offerAmount >= gstItem.ABOVEVALUE) {
              appliedGST = gstItem.ABOVEPER;
            }
          } else {
            appliedGST = newItem?.GST;
          }

          updatedData.push({
            ...newItem,
            stock: 1,
            GSTApplied: appliedGST,
            SMCODE: smCodeData[0]?.CODE ?? "",
          });
        });

        const totalBasic = updatedData.reduce((acc, item) => {
          const offer = Number(item.offer) || 0;
          const qty = Number(item.stock) || 0;
          const gst = Number(item.GSTApplied) || 0;
          const netAmt = qty * offer;
          return acc + netAmt * (100 / (100 + gst));
        }, 0);
        setTotalBasicAmount(totalBasic);

        const totalGst = updatedData.reduce((acc, item) => {
          const offer = Number(item.offer) || 0;
          const qty = Number(item.stock) || 0;
          const gst = Number(item.GSTApplied) || 0;
          const netAmt = qty * offer;
          const basic = netAmt * (100 / (100 + gst));
          return acc + basic * (gst / 100);
        }, 0);
        setTotalGstAmt(totalGst);

        setTotalCGSTAmt(totalGst / 2);
        setTotalSGSTAmt(totalGst / 2);

        const totalAmt = updatedData.reduce(
          (acc, item) =>
            acc + (Number(item.offer) || 0) * (Number(item.stock) || 0),
          0,
        );
        setTotalAmount(totalAmt);
        setTotalGrossAmount(totalAmt);
        setTotalNetAmount(totalAmt);

        const gstGroupedMap = new Map();
        updatedData.forEach((item) => {
          const key = item.GSTApplied;
          const netAmt = item.stock * item.offer;
          const basicAmt = netAmt * (100 / (100 + key));
          const gstAmt = netAmt * (key / 100);

          if (!gstGroupedMap.has(key)) {
            gstGroupedMap.set(key, {
              GST: key,
              CGST_RATE: key / 2,
              Basic_amt: 0,
              CGST_AMT: 0,
              SGST: key / 2,
              SGST_AMT: 0,
              NET_AMT: 0,
            });
          }
          const g = gstGroupedMap.get(key);
          g.Basic_amt += basicAmt;
          g.CGST_AMT += gstAmt / 2;
          g.SGST_AMT += gstAmt / 2;
          g.NET_AMT += netAmt;
        });
        setTotalGstData(Array.from(gstGroupedMap.values()));

        return updatedData;
      });
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const homeBillData = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=PRODUCT_MASTER&where=SHORTKEY='${tagNo}'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (!Array.isArray(data) || data.length === 0) {
        setTagNo();
        return;
      }
      setTagNo();
      setProductData(data);
      setDesignCode(data[0]?.SHORTKEY);
      setHomeDetailsOpen(true);
    } catch (error) {
      console.error(error);
    }
  };

  const OpeningLedgerBalanceAPI = async (phone, name) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=TRANS_ENTRY_DATA_CUST&where=AGENTNAME='${phone}' AND PARTYNAME='${name}'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        const nama = data.reduce(
          (acc, item) => acc + (Number(item.NAMA) || 0),
          0,
        );
        const jama = data.reduce(
          (acc, item) => acc + (Number(item.JAMA) || 0),
          0,
        );
        setPrvBalance(nama - jama);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  const billNoDate = new Date(
    dayjs(billDate).startOf("day").format("YYYY-MM-DD"),
  ).toISOString();

  const createBarcodeDet = async (inv) => {
    const requestBody = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: billNo ? Number(billNo) : Number(inv),
        billdate: billDate ? billNoDate : date.toISOString(),
        street: userDetails?.Area || "-",
        custName: userDetails?.Custname || "-",
        sno: index + 1,
        itemcode: item?.DesignCode ? String(item.DesignCode) : "",
        itemname: String(item?.ProdName) ?? "",
        code: String(item?.Code) ?? "",
        compName: String(item?.CompName) ?? "",
        groupName: String(item?.GroupName) ?? "",
        smcode: String(item?.SMCODE) ?? "-",
        qty: Number(item?.stock) ?? 0,
        rate: Number(item?.CPrice) ?? 0,
        disper: Number(item?.Disper) ?? 0,
        disAmt: Number(item?.Disamt) ?? 0,
        actrate: String(item?.offer ?? ""),
        amount: String(item?.offer * item?.stock ?? ""),
        hid: Number(item?.HID) ?? 0,
        dPrice: Number(item?.DPrice) ?? 0,
        comm: Number(commToken) ?? 0,
        token: Number(item?.TOKEN) ?? 0,
        ptype: String(item?.PTYPE) ?? "",
        area: String(item?.Area) ?? "",
        partyname: String(item?.Partyname) ?? "",
        type: "B",
        vatper: 0,
        vatamt: 0,
        floor: String(item?.FLOOR) ?? "",
        wsalebill: false,
        appno: 0,
        invno: String(item?.InvNO) ?? "",
        colour: String(item?.COLOUR) ?? "",
        fitting: String(item?.FITTING) ?? "",
        sleves: String(item?.SLEVES) ?? "",
        ecode: String(item?.ECODE) ?? "",
        prodsize: String(item?.Prodsize) ?? "",
        station: "-",
        iteM_DIS: Number(item?.Disamt) ?? 0,
        iteM_ACTRATE: Number(item?.offer) ?? 0,
        scheck: false,
        hsncode: String(item?.HSNCODE) ?? "",
        gst: Number(item?.GSTApplied) ?? 0,
        gstamt: basicAmt * (item?.GSTApplied / 100) ?? 0,
        cgstrate: item?.GSTApplied / 2,
        cgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2 ?? 0,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2 ?? 0,
        igstrate: 0,
        igstamt: 0,
        basicamt: Number(basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "BILLING",
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: item?.stock ? Number(item.stock) : 0,
        refcode: "-",
        state: userDetails?.STATE || "",
        statecode: userDetails?.STATECODE || "",
        tinno: "-",
        idproof: "-",
        panno: "-",
        boxes: Number(item?.BOXES) ?? 0,
        loosepcs: Number(item?.LOOSEPCS) ?? 0,
        pfcharges: 0,
        cessper: 0,
        cessamt: 0,
        packpcs: Number(item?.PACKPCS) || 0,
        caseprice: 0,
        pcsprice: 0,
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: 0,
        ustatus: false,
        gstin: "-",
        estbillno: false,
        cloud_upload: true,
        billreduce: 0,
      };
    });
    try {
      await axios.post(`${CREATE_jwel}/api/ERP/InsertReturnData`, requestBody, {
        headers: { "Content-Type": "application/json", tenantName: tenantName },
      });
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createBarcodeMast = async (inv) => {
    const requestBody = [
      {
        billno: billNo ? billNo : inv,
        billdate: billDate ? billNoDate : date.toISOString(),
        street: userDetails?.Area || "-",
        custName: userDetails?.Custname || "-",
        add1: userDetails?.add1 || "-",
        phoneNo: userDetails?.Mobileno || "-",
        totamt: Number(totalAmount),
        discount: Number(totalDiSAmt),
        advAmt: Number(cashAmt),
        finalamt: Number(creditAmt),
        billtype: cashValue === "CREDIT" ? "CREDIT" : "CASH",
        lessAmt: 0,
        smcode: "-",
        pstatus: false,
        ebillno: 0,
        mode:
          cashValue === "CREDIT"
            ? "CASH"
            : cashValue === "CASH"
              ? "CASH"
              : "CARD",
        accNO: "-",
        cardno: cashValue === "CREDIT" ? "0" : cashValue === "CASH" ? "0" : "-",
        cardamt: Number(cardAmt || upiAmt || onlineAmt || 0),
        sTax: 0,
        flrcode: "-",
        esmCode: "-",
        days: 0,
        cStatus: true,
        card: 0,
        hid: 0,
        estno: 0,
        adD2: userDetails?.add2 || "-",
        billtime: billDate ? billNoDate : date,
        uname: loginName ?? "-",
        cancell: "NO",
        ctime: billDate ? billNoDate : date,
        cuname: "-",
        station: "mobile",
        billstatus: false,
        funame: "-",
        fstation: "-",
        reccash: 0,
        refcash: 0,
        wsalebill: false,
        appno: 0,
        ccause: "-",
        edisamt: 0,
        chqdate: billDate ? billNoDate : date.toISOString(),
        narration: "-",
        invpayableamt: Number(totalNetAmount),
        invpaidamt: Number(invPaidAmt),
        invrtnamt: 0,
        invbalamt: Number(creditAmt),
        invstatus: true,
        extradiscount: 0,
        prevpoints: 0,
        prevamt: 0,
        billpoints: 0,
        billvalue: 0,
        redimpoints: 0,
        redimamt: 0,
        totpoints: 0,
        totvalue: 0,
        prevcardno: "-",
        adjustments: 0,
        totgst: 0,
        totogstamt: Number(totalGstAmt),
        totcgstrate: 0,
        totcgstamt: Number(totalCGSTAmt),
        totsgstrate: 0,
        totsgstamt: Number(totalSGSTAmt),
        totigstrate: 0,
        totigstamt: 0,
        serialno: 0,
        salestype: "BILLING",
        custstation: userDetails?.STATION || "LOCAL",
        transport: "-",
        custtype: "CUSTOMER",
        stype: "BILLING",
        lrno: "-",
        lrdate: "-",
        shipstreet: "-",
        shipcustname: "-",
        shipadD1: "-",
        shipadD2: "-",
        shipphoneno: "-",
        shiptinno: "-",
        noofbags: "-",
        orderno: "-",
        orderdate: "-",
        dateofsupply: "-",
        placeofsupply: "-",
        company: "-",
        place: "-",
        branch: "-",
        bankaccno: "-",
        ifsccode: "-",
        state: "-",
        statecode: "-",
        shipstate: "-",
        shipstatecode: "-",
        bankname: "-",
        beatarea: "-",
        orddate: "-",
        gstin: "-",
        totbasicamt: Number(totalBasicAmount),
        totamtaftax: 0,
        salesper: 0,
        salesamt: 0,
        grossamt: Number(totalNetAmount),
        roundoff: 0,
        netamt: Number(totalNetAmount),
        tinno: "-",
        idproof: "-",
        panno: "-",
        purchno: "-",
        disamt: Number(totalDiscountAmt) || 0,
        schemeamt: 0,
        disper: Number(disPer) || 0,
        pinvno: "-",
        m_BTYPE: "-",
        m_BNO: "-",
        m_BDATE: "-",
        includinggst: false,
        acity: "-",
        agentname: "-",
        ustatus: false,
        estbillno: false,
        paymode: "-",
        totqty: totalQty,
        refundamt: 0,
        paidcard: Number(cardAmt),
        paidcheque: 0,
        paidonline: Number(onlineAmt),
        paidupi: Number(upiAmt),
        paidcash: Number(cashAmt),
        balance: Number(creditAmt),
        ctype: "RETAIL",
        withgst: false,
        marginper: 0,
        cloud_upload: true,
        couponredem: 0,
      },
    ];
    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/ERP/InsertReturnMast`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
      if (response?.status === 200) {
        invNoAPI();
        commissionAPI();
        handleReset();
        setCashValue("CASH");
        setCardAmt(0);
        setUpiAmt(0);
        setOnlineAmt(0);
        setCreditAmt(0);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createBarcodeEXBDet = async (inv) => {
    const requestBody = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const gstAmt = basicAmt * (item.GSTApplied / 100);
      const cGstAmt = (basicAmt * (item.GSTApplied / 100)) / 2;
      const sGstAmt = (basicAmt * (item.GSTApplied / 100)) / 2;
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: billNo ? billNo : inv,
        billdate: billDate
          ? dayjs(billDate).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
        street: userDetails?.Area || "",
        custName: userDetails?.Custname || "",
        sno: index + 1,
        itemcode: String(item?.DesignCode) ?? "",
        itemname: String(item?.ProdName) ?? "",
        code: String(item?.Code) ?? "",
        compName: String(item?.CompName) ?? "",
        groupName: String(item?.GroupName) ?? "",
        smcode: String(item?.SMCODE) ?? "-",
        qty: Number(-item?.stock) ?? 0,
        rate: Number(item?.CPrice) ?? 0,
        disper: Number(item?.Disper) ?? 0,
        disAmt: Number(item?.Disamt) ?? 0,
        actrate: String(item?.offer ?? ""),
        amount: String(item?.offer * item?.stock ?? ""),
        hid: Number(item?.HID) ?? 0,
        dPrice: Number(item?.DPrice) ?? 0,
        comm: Number(-commToken) ?? 0,
        token: Number(-item?.TOKEN) ?? 0,
        ptype: String(item?.PTYPE) ?? "",
        area: String(item?.Area) ?? "",
        partyname: String(item?.Partyname) ?? "",
        type: "RB",
        vatper: 0,
        vatamt: 0,
        floor: String(item?.FLOOR) ?? "",
        wsalebill: false,
        appno: 0,
        invno: String(item?.InvNO) ?? "",
        invdate: billDate
          ? dayjs(billDate).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
        colour: String(item?.COLOUR) ?? "",
        fitting: String(item?.FITTING) ?? "",
        sleves: String(item?.SLEVES) ?? "",
        ecode: String(item?.ECODE) ?? "",
        prodsize: String(item?.Prodsize) ?? "",
        station: "-",
        iteM_DIS: Number(item?.Disamt) ?? 0,
        iteM_ACTRATE: Number(item?.offer) ?? 0,
        scheck: false,
        hsncode: String(item?.HSNCODE) ?? "",
        gst: Number(item?.GSTApplied) ?? 0,
        gstamt: Number(-gstAmt) ?? 0,
        cgstrate: item?.GSTApplied / 2,
        cgstamt: Number(-cGstAmt) ?? 0,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: Number(-sGstAmt) ?? 0,
        igstrate: 0,
        igstamt: 0,
        basicamt: Number(-basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "BILLING",
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: Number(-item?.stock) ?? 0,
        refcode: "-",
        state: userDetails?.STATE || "",
        statecode: userDetails?.STATECODE || "",
        tinno: "-",
        idproof: "-",
        panno: "-",
        boxes: Number(item?.BOXES) ?? 0,
        loosepcs: Number(item?.LOOSEPCS) ?? 0,
        pfcharges: 0,
        cessper: 0,
        cessamt: 0,
        packpcs: Number(item?.PACKPCS) || 0,
        caseprice: 0,
        pcsprice: 0,
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: 0,
        ustatus: false,
        gstin: "-",
        estbillno: false,
        cloud_upload: true,
      };
    });
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/InsertBillItemsDet`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const paymentModeAPI = async (inv) => {
    let requestBody = [];
    const commonFields = {
      entrydate: billDate
        ? dayjs(billDate).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      entryno: billNo ? billNo : inv,
      vno: String(billNo ? billNo : inv),
      vdate: billDate
        ? dayjs(billDate).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      scode: 4,
      description: "-",
      salestype: "BILLING",
      hid: 0,
      sno: 0,
      cloud_upload: true,
    };

    if (cashValue === "CASH") {
      requestBody = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "   SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt === 0
    ) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${billNo ? billNo : inv}@ONLINE-SALE`,
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${billNo ? billNo : inv}@${cashValue === "CARD"
              ? "CARD-SALE"
              : cashValue === "UPI"
                ? "UPI-SALE"
                : "ONLINE-SALE"
            }`,
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          tranS_TYPE: "ONLINE SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt > 0
    ) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${billNo ? billNo : inv}@ONLINE-SALE`,
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${billNo ? billNo : inv}@${cashValue === "CARD"
              ? "CARD-SALE"
              : cashValue === "UPI"
                ? "UPI-SALE"
                : "ONLINE-SALE"
            }`,
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          tranS_TYPE: "CASH SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: totalNetAmount - cardAmt - upiAmt - onlineAmt - creditAmt,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0 && cashAmt > 0) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: Number(totalNetAmount),
          namaamount: 0,
          tranS_TYPE: "   SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: Number(cashAmt),
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0) {
      requestBody = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: Number(totalNetAmount),
          namaamount: 0,
          tranS_TYPE: "   SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: `INVNO:${billNo ? billNo : inv}@CASH-SALE`,
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    }

    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/InsertSingleEntryData`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const onlinePayModeAPI = async (inv) => {
    const requestBody = [
      {
        billno: billNo ? Number(billNo) : Number(inv),
        billdate: billDate ? billNoDate : date.toISOString(),
        bal: Number(totalNetAmount),
        sno: 1,
        paymode: cashValue,
        accno:
          cashValue === "CARD"
            ? cardAcc
            : cashValue === "UPI"
              ? upiAcc
              : onlineAcc,
        narr: "-",
        amt:
          cashValue === "CARD"
            ? Number(cardAmt)
            : cashValue === "UPI"
              ? Number(upiAmt)
              : Number(onlineAmt),
        cntrname: "",
        stype: "SALES",
        ptype: cashValue,
        cloud_upload: true,
      },
    ];
    try {
      await axios.post(`${CREATE_jwel}/api/ERP/InsertORGCardDet`, requestBody, {
        headers: { "Content-Type": "application/json", tenantName: tenantName },
      });
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createLedgerBalanceAPI = async (inv) => {
    const requestBody = [
      {
        area: userDetails?.Area || "-",
        partyname: userDetails?.Custname || "-",
        billno: billNo ? String(billNo) : String(inv),
        billdate: billDate ? billNoDate : date.toISOString(),
        entryno: billNo ? billNo : inv,
        entrydate: billDate ? billNoDate : date.toISOString(),
        particulars: "SALE RETURN",
        jamaqty: 0,
        namaqty: Number(totalQty) ?? 0,
        jama: 0,
        nama: Number(creditAmt) ?? 0,
        narration: "-",
        hid: 0,
        agentcity: "-",
        agentname: String(userDetails?.Mobileno) || "-",
        tranS_TYPE: "SALE RETURN",
        cusT_TYPE: "CUSTOMER",
        sno: 0,
        pstatus: "",
        salestype: "SALE RETURN",
        chequeno: "-",
        chqdate: billDate ? billNoDate : date.toISOString(),
        chqamt: 0,
        chqstatus: false,
        accno: "-",
        chqcancell: "NO",
        description: "-",
        cloud_upload: false,
      },
    ];
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/InsertTransEntryDataCust`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createStockAddAPI = async () => {
    const requestBody = barCodeData.map((item) => ({
      code: item?.DesignCode,
      qty: Number(item?.stock),
    }));
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/StockUpdate?action=ADD`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createStockUpdateAPI = async () => {
    const requestBody = updatedData.map((item) => ({
      code: item?.DesignCode,
      qty: Number(item?.stock),
    }));
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/StockUpdate?action=ABC`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createReturnBillSave = async () => {
    const billNoValue = billNo ? billNo : 0;
    const billDateStr = billDate
      ? dayjs(billDate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
    const masterDate = billDate ? billNoDate : date.toISOString();

    // ---- returnData (from createBarcodeDet) ----
    const returnData = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: 0,
        billdate: masterDate,
        street: userDetails?.Area || "-",
        custName: userDetails?.Custname || "-",
        sno: index + 1,
        itemcode: item?.DesignCode ? String(item.DesignCode) : "",
        itemname: String(item?.ProdName) ?? "",
        code: String(item?.Code) ?? "",
        compName: String(item?.CompName) ?? "",
        groupName: String(item?.GroupName) ?? "",
        smcode: String(item?.SMCODE) ?? "-",
        qty: Number(item?.stock) ?? 0,
        rate: Number(item?.CPrice) ?? 0,
        disper: Number(item?.Disper) ?? 0,
        disAmt: Number(item?.Disamt) ?? 0,
        actrate: String(item?.offer ?? ""),
        amount: String(item?.offer * item?.stock ?? ""),
        hid: Number(item?.HID) ?? 0,
        dPrice: Number(item?.DPrice) ?? 0,
        comm: Number(commToken) ?? 0,
        token: Number(item?.TOKEN) ?? 0,
        ptype: String(item?.PTYPE) ?? "",
        area: String(item?.Area) ?? "",
        partyname: String(item?.Partyname) ?? "",
        type: "RB",
        vatper: 0,
        vatamt: 0,
        floor: String(item?.FLOOR) ?? "",
        wsalebill: false,
        appno: 0,
        invno: String(item?.InvNO) ?? "",
        colour: String(item?.COLOUR) ?? "",
        fitting: String(item?.FITTING) ?? "",
        sleves: String(item?.SLEVES) ?? "",
        ecode: String(item?.ECODE) ?? "",
        prodsize: String(item?.Prodsize) ?? "",
        station: "-",
        iteM_DIS: Number(item?.Disamt) ?? 0,
        iteM_ACTRATE: Number(item?.offer) ?? 0,
        scheck: false,
        hsncode: String(item?.HSNCODE) ?? "",
        gst: Number(item?.GSTApplied) ?? 0,
        gstamt: basicAmt * (item?.GSTApplied / 100) ?? 0,
        cgstrate: item?.GSTApplied / 2,
        cgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2 ?? 0,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2 ?? 0,
        igstrate: 0,
        igstamt: 0,
        basicamt: Number(basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "SALE RETURN",
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: item?.stock ? Number(item.stock) : 0,
        refcode: "-",
        state: userDetails?.STATE || "",
        statecode: userDetails?.STATECODE || "",
        tinno: "-",
        idproof: "-",
        panno: "-",
        boxes: Number(item?.BOXES) ?? 0,
        loosepcs: Number(item?.LOOSEPCS) ?? 0,
        pfcharges: 0,
        cessper: 0,
        cessamt: 0,
        packpcs: Number(item?.PACKPCS) || 0,
        caseprice: 0,
        pcsprice: 0,
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: 0,
        ustatus: false,
        gstin: "-",
        estbillno: false,
        cloud_upload: true,
        billreduce: 0,
      };
    });

    // ---- billItemsDet (from createBarcodeEXBDet) ----
    const billItemsDet = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const gstAmt = basicAmt * (item.GSTApplied / 100);
      const cGstAmt = (basicAmt * (item.GSTApplied / 100)) / 2;
      const sGstAmt = (basicAmt * (item.GSTApplied / 100)) / 2;
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: 0,
        billdate: billDateStr,
        street: userDetails?.Area || "",
        custName: userDetails?.Custname || "",
        sno: index + 1,
        itemcode: String(item?.DesignCode) ?? "",
        itemname: String(item?.ProdName) ?? "",
        code: String(item?.Code) ?? "",
        compName: String(item?.CompName) ?? "",
        groupName: String(item?.GroupName) ?? "",
        smcode: String(item?.SMCODE) ?? "-",
        qty: Number(item?.stock) ?? 0,
        rate: Number(item?.CPrice) ?? 0,
        disper: Number(item?.Disper) ?? 0,
        disAmt: Number(item?.Disamt) ?? 0,
        actrate: String(item?.offer ?? ""),
        amount: String(item?.offer * item?.stock ?? ""),
        hid: Number(item?.HID) ?? 0,
        dPrice: Number(item?.DPrice) ?? 0,
        comm: Number(commToken) ?? 0,
        token: Number(item?.TOKEN) ?? 0,
        ptype: String(item?.PTYPE) ?? "",
        area: String(item?.Area) ?? "",
        partyname: String(item?.Partyname) ?? "",
        type: "RB",
        vatper: 0,
        vatamt: 0,
        floor: String(item?.FLOOR) ?? "",
        wsalebill: false,
        appno: 0,
        invno: String(item?.InvNO) ?? "",
        invdate: billDateStr,
        colour: String(item?.COLOUR) ?? "",
        fitting: String(item?.FITTING) ?? "",
        sleves: String(item?.SLEVES) ?? "",
        ecode: String(item?.ECODE) ?? "",
        prodsize: String(item?.Prodsize) ?? "",
        station: "-",
        iteM_DIS: Number(item?.Disamt) ?? 0,
        iteM_ACTRATE: Number(item?.offer) ?? 0,
        scheck: false,
        hsncode: String(item?.HSNCODE) ?? "",
        gst: Number(item?.GSTApplied) ?? 0,
        gstamt: Number(gstAmt) ?? 0,
        cgstrate: item?.GSTApplied / 2,
        cgstamt: Number(cGstAmt) ?? 0,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: Number(sGstAmt) ?? 0,
        igstrate: 0,
        igstamt: 0,
        basicamt: Number(basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "SALE RETURN",
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: Number(item?.stock) ?? 0,
        refcode: "-",
        state: userDetails?.STATE || "",
        statecode: userDetails?.STATECODE || "",
        tinno: "-",
        idproof: "-",
        panno: "-",
        boxes: Number(item?.BOXES) ?? 0,
        loosepcs: Number(item?.LOOSEPCS) ?? 0,
        pfcharges: 0,
        cessper: 0,
        cessamt: 0,
        packpcs: Number(item?.PACKPCS) || 0,
        caseprice: 0,
        pcsprice: 0,
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: 0,
        ustatus: false,
        gstin: "-",
        estbillno: false,
        cloud_upload: true,
        billreduce: 0,
      };
    });

    // ---- master (from createBarcodeMast) ----
    const master = {
      billno: 0,
      billdate: masterDate,
      street: userDetails?.Area || "-",
      custName: userDetails?.Custname || "-",
      add1: userDetails?.add1 || "-",
      phoneNo: userDetails?.Mobileno || "-",
      totamt: Number(totalAmount),
      discount: Number(totalDiSAmt),
      advAmt: Number(cashAmt),
      finalamt: Number(creditAmt),
      billtype: cashValue === "CREDIT" ? "CREDIT" : "CASH",
      lessAmt: 0,
      smcode: "-",
      pstatus: false,
      ebillno: 0,
      mode:
        cashValue === "CREDIT"
          ? "CASH"
          : cashValue === "CASH"
            ? "CASH"
            : "CARD",
      accNO: "-",
      cardno: cashValue === "CREDIT" ? "0" : cashValue === "CASH" ? "0" : "-",
      cardamt: Number(cardAmt || upiAmt || onlineAmt || 0),
      sTax: 0,
      flrcode: "-",
      esmCode: "-",
      days: 0,
      cStatus: true,
      card: 0,
      hid: 0,
      estno: 0,
      adD2: userDetails?.add2 || "-",
      billtime: masterDate,
      uname: loginName ?? "-",
      cancell: "NO",
      ctime: masterDate,
      cuname: "-",
      station: "mobile",
      billstatus: false,
      funame: "-",
      fstation: "-",
      reccash: 0,
      refcash: 0,
      wsalebill: false,
      appno: 0,
      ccause: "-",
      edisamt: 0,
      chqdate: masterDate,
      narration: "-",
      invpayableamt: Number(totalNetAmount),
      invpaidamt: Number(invPaidAmt),
      invrtnamt: 0,
      invbalamt: Number(creditAmt),
      invstatus: true,
      extradiscount: 0,
      prevpoints: 0,
      prevamt: 0,
      billpoints: 0,
      billvalue: 0,
      redimpoints: 0,
      redimamt: 0,
      totpoints: 0,
      totvalue: 0,
      prevcardno: "-",
      adjustments: 0,
      totgst: 0,
      totogstamt: Number(totalGstAmt),
      totcgstrate: 0,
      totcgstamt: Number(totalCGSTAmt),
      totsgstrate: 0,
      totsgstamt: Number(totalSGSTAmt),
      totigstrate: 0,
      totigstamt: 0,
      serialno: 0,
      salestype: "SALE RETURN",
      custstation: userDetails?.STATION || "LOCAL",
      transport: "-",
      custtype: "CUSTOMER",
      stype: "SALE RETURN",
      lrno: "-",
      lrdate: "-",
      shipstreet: "-",
      shipcustname: "-",
      shipadD1: "-",
      shipadD2: "-",
      shipphoneno: "-",
      shiptinno: "-",
      noofbags: "-",
      orderno: "-",
      orderdate: "-",
      dateofsupply: "-",
      placeofsupply: "-",
      company: "-",
      place: "-",
      branch: "-",
      bankaccno: "-",
      ifsccode: "-",
      state: "-",
      statecode: "-",
      shipstate: "-",
      shipstatecode: "-",
      bankname: "-",
      beatarea: "-",
      orddate: "-",
      gstin: "-",
      totbasicamt: Number(totalBasicAmount),
      totamtaftax: 0,
      salesper: 0,
      salesamt: 0,
      grossamt: Number(totalNetAmount),
      roundoff: 0,
      netamt: Number(totalNetAmount),
      tinno: "-",
      idproof: "-",
      panno: "-",
      purchno: "-",
      disamt: Number(totalDiscountAmt) || 0,
      schemeamt: 0,
      disper: Number(disPer) || 0,
      pinvno: "-",
      m_BTYPE: "-",
      m_BNO: "-",
      m_BDATE: "-",
      includinggst: false,
      acity: "-",
      agentname: "-",
      ustatus: false,
      estbillno: false,
      paymode: "-",
      totqty: totalQty,
      refundamt: 0,
      paidcard: Number(cardAmt),
      paidcheque: 0,
      paidonline: Number(onlineAmt),
      paidupi: Number(upiAmt),
      paidcash: Number(cashAmt),
      balance: Number(creditAmt),
      ctype: "RETAIL",
      withgst: false,
      marginper: 0,
      cloud_upload: true,
      couponredem: 0,
    };

    // ---- singleEntryData (from paymentModeAPI) ----
    const commonFields = {
      entrydate: billDateStr,
      entryno: 0,
      vno: "0",
      vdate: billDateStr,
      scode: 4,
      description: "-",
      salestype: "SALE RETURN",
      hid: 0,
      sno: 0,
      clouD_UPLOAD: true,
      outstandinG_CHEQUE: "-",
    };

    let singleEntryData = [];

    if (cashValue === "CASH") {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt === 0
    ) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          tranS_TYPE: "ONLINE SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt > 0
    ) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          tranS_TYPE: "CASH SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: totalNetAmount - cardAmt - upiAmt - onlineAmt - creditAmt,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0 && cashAmt > 0) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: Number(totalNetAmount),
          namaamount: 0,
          tranS_TYPE: "   SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: Number(cashAmt),
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: Number(totalNetAmount),
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    }

    // ---- orgCardDet (from onlinePayModeAPI) ----
    let orgCardDet = [];
    if (
      (barCodeData.length > 0 && cashValue === "CARD") ||
      cashValue === "UPI" ||
      cashValue === "ONLINE"
    ) {
      orgCardDet = [
        {
          billno: 0,
          billdate: masterDate,
          bal: Number(totalNetAmount),
          sno: 1,
          paymode: cashValue,
          accno:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          narr: "-",
          amt:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          cntrname: "",
          stype: "SALE RETURN",
          ptype: cashValue,
          cloud_upload: true,
        },
      ];
    }

    // ---- transEntryDataCust (from createLedgerBalanceAPI) ----
    let transEntryDataCust = [];
    if (creditAmt > 0) {
      transEntryDataCust = [
        {
          area: userDetails?.Area || "-",
          partyname: userDetails?.Custname || "-",
          billno: "0",
          billdate: masterDate,
          entryno: 0,
          entrydate: masterDate,
          particulars: "SALE RETURN",
          jamaqty: 0,
          namaqty: Number(totalQty) ?? 0,
          jama: 0,
          nama: Number(creditAmt) ?? 0,
          narration: "-",
          hid: 0,
          agentcity: "-",
          agentname: String(userDetails?.Mobileno) || "-",
          tranS_TYPE: "SALE RETURN",
          cusT_TYPE: "CUSTOMER",
          sno: 0,
          pstatus: "",
          salestype: "SALE RETURN",
          chequeno: "-",
          chqdate: masterDate,
          chqamt: 0,
          chqstatus: false,
          accno: "-",
          chqcancell: "NO",
          description: "-",
          cloud_upload: false,
        },
      ];
    }

    // ---- final combined payload ----
    const payload = {
      master,
      returnData,
      billItemsDet,
      singleEntryData,
      orgCardDet,
      transEntryDataCust,
    };

    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/SaleReturn/Save`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
      if (response?.data?.isInsert === true) {
        invNoAPI();
        commissionAPI();
        handleReset();
        setCashValue("CASH");
        setCardAmt(0);
        setUpiAmt(0);
        setOnlineAmt(0);
        setCreditAmt(0);
      }
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createReturnBillUpdate = async () => {
    const billNoValue = billNo ? billNo : 0;
    const billDateStr = billDate
      ? dayjs(billDate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
    const masterDate = billDate ? billNoDate : date.toISOString();

    // ---- returnData (from createBarcodeDet) ----
    const returnData = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: Number(billNoValue),
        billdate: masterDate,
        street: userDetails?.Area || "-",
        custName: userDetails?.Custname || "-",
        sno: index + 1,
        itemcode: item?.DesignCode ? String(item.DesignCode) : "",
        itemname: String(item?.ProdName) ?? "",
        code: String(item?.Code) ?? "",
        compName: String(item?.CompName) ?? "",
        groupName: String(item?.GroupName) ?? "",
        smcode: String(item?.SMCODE) ?? "-",
        qty: Number(item?.stock) ?? 0,
        rate: Number(item?.CPrice) ?? 0,
        disper: Number(item?.Disper) ?? 0,
        disAmt: Number(item?.Disamt) ?? 0,
        actrate: String(item?.offer ?? ""),
        amount: String(item?.offer * item?.stock ?? ""),
        hid: Number(item?.HID) ?? 0,
        dPrice: Number(item?.DPrice) ?? 0,
        comm: Number(commToken) ?? 0,
        token: Number(item?.TOKEN) ?? 0,
        ptype: String(item?.PTYPE) ?? "",
        area: String(item?.Area) ?? "",
        partyname: String(item?.Partyname) ?? "",
        type: "RB",
        vatper: 0,
        vatamt: 0,
        floor: String(item?.FLOOR) ?? "",
        wsalebill: false,
        appno: 0,
        invno: String(item?.InvNO) ?? "",
        colour: String(item?.COLOUR) ?? "",
        fitting: String(item?.FITTING) ?? "",
        sleves: String(item?.SLEVES) ?? "",
        ecode: String(item?.ECODE) ?? "",
        prodsize: String(item?.Prodsize) ?? "",
        station: "-",
        iteM_DIS: Number(item?.Disamt) ?? 0,
        iteM_ACTRATE: Number(item?.offer) ?? 0,
        scheck: false,
        hsncode: String(item?.HSNCODE) ?? "",
        gst: Number(item?.GSTApplied) ?? 0,
        gstamt: basicAmt * (item?.GSTApplied / 100) ?? 0,
        cgstrate: item?.GSTApplied / 2,
        cgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2 ?? 0,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: (basicAmt * (item?.GSTApplied / 100)) / 2 ?? 0,
        igstrate: 0,
        igstamt: 0,
        basicamt: Number(basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "SALE RETURN",
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: item?.stock ? Number(item.stock) : 0,
        refcode: "-",
        state: userDetails?.STATE || "",
        statecode: userDetails?.STATECODE || "",
        tinno: "-",
        idproof: "-",
        panno: "-",
        boxes: Number(item?.BOXES) ?? 0,
        loosepcs: Number(item?.LOOSEPCS) ?? 0,
        pfcharges: 0,
        cessper: 0,
        cessamt: 0,
        packpcs: Number(item?.PACKPCS) || 0,
        caseprice: 0,
        pcsprice: 0,
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: 0,
        ustatus: false,
        gstin: "-",
        estbillno: false,
        cloud_upload: true,
        billreduce: 0,
      };
    });

    // ---- billItemsDet (from createBarcodeEXBDet) ----
    const billItemsDet = barCodeData.map((item, index) => {
      const basicAmt =
        item.stock * item.offer * (100 / (100 + item.GSTApplied));
      const gstAmt = basicAmt * (item.GSTApplied / 100);
      const cGstAmt = (basicAmt * (item.GSTApplied / 100)) / 2;
      const sGstAmt = (basicAmt * (item.GSTApplied / 100)) / 2;
      const commValue = Number(item.stock * item.offer);
      const commission = (commValue * comm) / 100;
      const commToken = item?.TOKEN > 0 ? 0 : commission;
      return {
        billno: Number(billNoValue),
        billdate: billDateStr,
        street: userDetails?.Area || "",
        custName: userDetails?.Custname || "",
        sno: index + 1,
        itemcode: String(item?.DesignCode) ?? "",
        itemname: String(item?.ProdName) ?? "",
        code: String(item?.Code) ?? "",
        compName: String(item?.CompName) ?? "",
        groupName: String(item?.GroupName) ?? "",
        smcode: String(item?.SMCODE) ?? "-",
        qty: Number(-item?.stock) ?? 0,
        rate: Number(item?.CPrice) ?? 0,
        disper: Number(item?.Disper) ?? 0,
        disAmt: Number(item?.Disamt) ?? 0,
        actrate: String(item?.offer ?? ""),
        amount: String(item?.offer * item?.stock ?? ""),
        hid: Number(item?.HID) ?? 0,
        dPrice: Number(item?.DPrice) ?? 0,
        comm: Number(-commToken) ?? 0,
        token: Number(-item?.TOKEN) ?? 0,
        ptype: String(item?.PTYPE) ?? "",
        area: String(item?.Area) ?? "",
        partyname: String(item?.Partyname) ?? "",
        type: "RB",
        vatper: 0,
        vatamt: 0,
        floor: String(item?.FLOOR) ?? "",
        wsalebill: false,
        appno: 0,
        invno: String(item?.InvNO) ?? "",
        invdate: billDateStr,
        colour: String(item?.COLOUR) ?? "",
        fitting: String(item?.FITTING) ?? "",
        sleves: String(item?.SLEVES) ?? "",
        ecode: String(item?.ECODE) ?? "",
        prodsize: String(item?.Prodsize) ?? "",
        station: "-",
        iteM_DIS: Number(item?.Disamt) ?? 0,
        iteM_ACTRATE: Number(item?.offer) ?? 0,
        scheck: false,
        hsncode: String(item?.HSNCODE) ?? "",
        gst: Number(item?.GSTApplied) ?? 0,
        gstamt: Number(-gstAmt) ?? 0,
        cgstrate: item?.GSTApplied / 2,
        cgstamt: Number(-cGstAmt) ?? 0,
        sgstrate: item?.GSTApplied / 2,
        sgstamt: Number(-sGstAmt) ?? 0,
        igstrate: 0,
        igstamt: 0,
        basicamt: Number(-basicAmt) ?? 0,
        serialno: 0,
        brandcode: "0",
        salestype: "SALE RETURN",
        fsize: "-",
        tsize: "-",
        differ: "-",
        actqty: Number(-item?.stock) ?? 0,
        refcode: "-",
        state: userDetails?.STATE || "",
        statecode: userDetails?.STATECODE || "",
        tinno: "-",
        idproof: "-",
        panno: "-",
        boxes: Number(item?.BOXES) ?? 0,
        loosepcs: Number(item?.LOOSEPCS) ?? 0,
        pfcharges: 0,
        cessper: 0,
        cessamt: 0,
        packpcs: Number(item?.PACKPCS) || 0,
        caseprice: 0,
        pcsprice: 0,
        casepricers: 0,
        pcspricers: 0,
        measurementtype: "-",
        tokenper: 0,
        ustatus: false,
        gstin: "-",
        estbillno: false,
        cloud_upload: true,
        billreduce: 0,
      };
    });

    // ---- master (from createBarcodeMast) ----
    const master = {
      billno: Number(billNoValue),
      billdate: masterDate,
      street: userDetails?.Area || "-",
      custName: userDetails?.Custname || "-",
      add1: userDetails?.add1 || "-",
      phoneNo: userDetails?.Mobileno || "-",
      totamt: Number(totalAmount),
      discount: Number(totalDiSAmt),
      advAmt: Number(cashAmt),
      finalamt: Number(creditAmt),
      billtype: cashValue === "CREDIT" ? "CREDIT" : "CASH",
      lessAmt: 0,
      smcode: "-",
      pstatus: false,
      ebillno: 0,
      mode:
        cashValue === "CREDIT"
          ? "CASH"
          : cashValue === "CASH"
            ? "CASH"
            : "CARD",
      accNO: "-",
      cardno: cashValue === "CREDIT" ? "0" : cashValue === "CASH" ? "0" : "-",
      cardamt: Number(cardAmt || upiAmt || onlineAmt || 0),
      sTax: 0,
      flrcode: "-",
      esmCode: "-",
      days: 0,
      cStatus: true,
      card: 0,
      hid: 0,
      estno: 0,
      adD2: userDetails?.add2 || "-",
      billtime: masterDate,
      uname: loginName ?? "-",
      cancell: "NO",
      ctime: masterDate,
      cuname: "-",
      station: "mobile",
      billstatus: false,
      funame: "-",
      fstation: "-",
      reccash: 0,
      refcash: 0,
      wsalebill: false,
      appno: 0,
      ccause: "-",
      edisamt: 0,
      chqdate: masterDate,
      narration: "-",
      invpayableamt: Number(totalNetAmount),
      invpaidamt: Number(invPaidAmt),
      invrtnamt: 0,
      invbalamt: Number(creditAmt),
      invstatus: true,
      extradiscount: 0,
      prevpoints: 0,
      prevamt: 0,
      billpoints: 0,
      billvalue: 0,
      redimpoints: 0,
      redimamt: 0,
      totpoints: 0,
      totvalue: 0,
      prevcardno: "-",
      adjustments: 0,
      totgst: 0,
      totogstamt: Number(totalGstAmt),
      totcgstrate: 0,
      totcgstamt: Number(totalCGSTAmt),
      totsgstrate: 0,
      totsgstamt: Number(totalSGSTAmt),
      totigstrate: 0,
      totigstamt: 0,
      serialno: 0,
      salestype: "SALE RETURN",
      custstation: userDetails?.STATION || "LOCAL",
      transport: "-",
      custtype: "CUSTOMER",
      stype: "SALE RETURN",
      lrno: "-",
      lrdate: "-",
      shipstreet: "-",
      shipcustname: "-",
      shipadD1: "-",
      shipadD2: "-",
      shipphoneno: "-",
      shiptinno: "-",
      noofbags: "-",
      orderno: "-",
      orderdate: "-",
      dateofsupply: "-",
      placeofsupply: "-",
      company: "-",
      place: "-",
      branch: "-",
      bankaccno: "-",
      ifsccode: "-",
      state: "-",
      statecode: "-",
      shipstate: "-",
      shipstatecode: "-",
      bankname: "-",
      beatarea: "-",
      orddate: "-",
      gstin: "-",
      totbasicamt: Number(totalBasicAmount),
      totamtaftax: 0,
      salesper: 0,
      salesamt: 0,
      grossamt: Number(totalNetAmount),
      roundoff: 0,
      netamt: Number(totalNetAmount),
      tinno: "-",
      idproof: "-",
      panno: "-",
      purchno: "-",
      disamt: Number(totalDiscountAmt) || 0,
      schemeamt: 0,
      disper: Number(disPer) || 0,
      pinvno: "-",
      m_BTYPE: "-",
      m_BNO: "-",
      m_BDATE: "-",
      includinggst: false,
      acity: "-",
      agentname: "-",
      ustatus: false,
      estbillno: false,
      paymode: "-",
      totqty: totalQty,
      refundamt: 0,
      paidcard: Number(cardAmt),
      paidcheque: 0,
      paidonline: Number(onlineAmt),
      paidupi: Number(upiAmt),
      paidcash: Number(cashAmt),
      balance: Number(creditAmt),
      ctype: "RETAIL",
      withgst: false,
      marginper: 0,
      cloud_upload: true,
      couponredem: 0,
    };

    // ---- singleEntryData (from paymentModeAPI) ----
    const commonFields = {
      entrydate: billDateStr,
      entryno: Number(billNoValue),
      vno: String(billNoValue),
      vdate: billDateStr,
      scode: 4,
      description: "-",
      salestype: "SALE RETURN",
      hid: 0,
      sno: 0,
      clouD_UPLOAD: true,
      outstandinG_CHEQUE: "-",
    };

    let singleEntryData = [];

    if (cashValue === "CASH") {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt === 0
    ) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          tranS_TYPE: "ONLINE SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
      ];
    } else if (
      (cashValue === "CARD" || cashValue === "UPI" || cashValue === "ONLINE") &&
      totalAmt > 0
    ) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "ONLINE SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: totalNetAmount,
          namaamount: 0,
          tranS_TYPE: "ONLINE SALES",
          stype: "ONLINE SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: 0,
          namaamount:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          tranS_TYPE: "CASH SALES",
          stype: "BANK TRANS",
          paymode: cashValue,
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: totalNetAmount - cardAmt - upiAmt - onlineAmt - creditAmt,
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0 && cashAmt > 0) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: Number(totalNetAmount),
          namaamount: 0,
          tranS_TYPE: "   SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: "CASH BOOK",
          groupname: "CASH BOOK",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: Number(cashAmt),
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH BOOK",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    } else if (cashValue === "CREDIT" && creditAmt > 0) {
      singleEntryData = [
        {
          ...commonFields,
          ledgername: "CASH SALES",
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "",
          particulars: "",
          jamaamount: Number(totalNetAmount),
          namaamount: 0,
          tranS_TYPE: "CASH SALES",
          stype: "CASH SALES",
          paymode: "-",
        },
        {
          ...commonFields,
          ledgername: userDetails?.Custname,
          groupname: "CUSTOMER",
          subgroup: "-",
          maingroup: "CASH BOOK",
          particulars: "",
          jamaamount: 0,
          namaamount: Number(creditAmt),
          tranS_TYPE: "CASH SALES",
          stype: "CUSTOMER DUE",
          paymode: "-",
        },
      ];
    }

    // ---- orgCardDet (from onlinePayModeAPI) ----
    let orgCardDet = [];
    if (
      (barCodeData.length > 0 && cashValue === "CARD") ||
      cashValue === "UPI" ||
      cashValue === "ONLINE"
    ) {
      orgCardDet = [
        {
          billno: Number(billNoValue),
          billdate: masterDate,
          bal: Number(totalNetAmount),
          sno: 1,
          paymode: cashValue,
          accno:
            cashValue === "CARD"
              ? cardAcc
              : cashValue === "UPI"
                ? upiAcc
                : onlineAcc,
          narr: "-",
          amt:
            cashValue === "CARD"
              ? Number(cardAmt)
              : cashValue === "UPI"
                ? Number(upiAmt)
                : Number(onlineAmt),
          cntrname: "",
          stype: "SALE RETURN",
          ptype: cashValue,
          cloud_upload: true,
        },
      ];
    }

    // ---- transEntryDataCust (from createLedgerBalanceAPI) ----
    let transEntryDataCust = [];
    if (creditAmt > 0) {
      transEntryDataCust = [
        {
          area: userDetails?.Area || "-",
          partyname: userDetails?.Custname || "-",
          billno: String(billNoValue),
          billdate: masterDate,
          entryno: Number(billNoValue),
          entrydate: masterDate,
          particulars: "SALE RETURN",
          jamaqty: 0,
          namaqty: Number(totalQty) ?? 0,
          jama: 0,
          nama: Number(creditAmt) ?? 0,
          narration: "-",
          hid: 0,
          agentcity: "-",
          agentname: String(userDetails?.Mobileno) || "-",
          tranS_TYPE: "SALE RETURN",
          cusT_TYPE: "CUSTOMER",
          sno: 0,
          pstatus: "",
          salestype: "SALE RETURN",
          chequeno: "-",
          chqdate: masterDate,
          chqamt: 0,
          chqstatus: false,
          accno: "-",
          chqcancell: "NO",
          description: "-",
          cloud_upload: false,
        },
      ];
    }

    // ---- final combined payload ----
    const payload = {
      master,
      returnData,
      billItemsDet,
      singleEntryData,
      orgCardDet,
      transEntryDataCust,
    };

    try {
      const response = await axios.post(
        `${CREATE_jwel}/api/SaleReturn/Update`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
      if (response?.data?.isInsert === true) {
        invNoAPI();
        commissionAPI();
        handleReset();
        setCashValue("CASH");
        setCardAmt(0);
        setUpiAmt(0);
        setOnlineAmt(0);
        setCreditAmt(0);
      }
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const createCustomerDetailsAPI = async (value) => {
    const requestBody = [
      {
        street: "-",
        custname: value?.name || "-",
        add1: value?.address1 || "-",
        add2: value?.address2 || "-",
        add3: value?.address3 || "-",
        area: value?.city || "-",
        phoneno: value?.phone || "-",
        mobileno: value?.mobile1 || "-",
        cardno: "",
        mstatus: "",
        occupation: "",
        education: "",
        college: "",
        discount: 0,
        dob: value?.dob || "",
        annversary: value?.anniversary || "",
        state: value?.state || "-",
        gender: "",
        district: "",
        website: "",
        category: "",
        fax: "-",
        add4: value?.address4 || "-",
        tinno: value?.gstin || "-",
        points: 0,
        statecode: value?.stateCode || "",
        station: value?.locationType || "",
        cloud_upload: false,
      },
    ];
    try {
      await axios.post(`${CREATE_jwel}/api/ERP/InsertCustomer`, requestBody, {
        headers: { "Content-Type": "application/json", tenantName: tenantName },
      });
      userDetailsAPI(value?.mobile1);
      setFormValues({});
      setOpen(false);
      smCodeRef.current?.focus();
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const holdMastNoAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithOrder?tableName=CREDIT_BILLMAST_HOLD&order=BILLNO DESC`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setHoldData(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const modifyBillOnlineAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=ORG_CARDDET&where=BILLNO=${no} AND STYPE='SLAE RETURN'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        if (data[0]?.PTYPE === "CARD") {
          setCashValue("CARD");
          setCardAmt(data[0]?.AMT);
        } else if (data[0]?.PTYPE === "UPI") {
          setCashValue("UPI");
          setUpiAmt(data[0]?.AMT);
        } else if (data[0]?.PTYPE === "ONLINE") {
          setCashValue("ONLINE");
          setOnlineAmt(data[0]?.AMT);
        } else {
          setCashValue("CASH");
        }
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const modifyBillOpeningLedgerAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=TRANS_ENTRY_DATA_CUST&where=ENTRYNO=${no} AND SALESTYPE='SALE RETURN'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        if (data[0]?.NAMA > 0) {
          setCashValue("CREDIT");
          setCreditAmt(data[0]?.NAMA);
        }
        userGetDetailsAPI(data[0]?.AGENTNAME);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const modifyDetAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=RETURN_DATA&where=BILLNO=${no}`,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
      let data = response?.data;
      const modifiedData = data.map((item) => ({
        ACITY: "-",
        AGENTNAME: "-",
        Area: item?.AREA,
        BOXES: item?.BOXES,
        BRANCHNAME: "-",
        CASERATECP: null,
        CASERATEDP: null,
        CASERATERP: null,
        CGSTAMT: item?.CGSTAMT,
        CGSTRATE: item?.CGSTRATE,
        COLOUR: item?.COLOUR,
        CPrice: item?.rate,
        CTOKEN: 0,
        Code: item?.code,
        CompName: item?.CompName,
        DPrice: item?.DPrice,
        DesignCode: item?.ITEMCODE,
        Disamt: item?.ITEM_DIS,
        Disper: item?.DISPER,
        ECODE: item?.ECODE,
        ENTRYDATE: "-",
        ENTRYNO: 0,
        EQTY: 0,
        EXPDATE: null,
        FITTING: item?.FITTING,
        FLOOR: item?.FLOOR,
        FYEAR: "-",
        GST: item?.GST,
        GSTAMT: item?.GSTAMT,
        GrosDPrice: item?.ITEM_ACTRATE,
        GroupName: item?.GroupName,
        HID: item?.HID,
        HSNCODE: item?.HSNCODE,
        ICODETYPE: "-",
        IGSTAMT: item?.IGSTAMT,
        IGSTRATE: item?.IGSTRATE,
        InvNO: item?.INVNO,
        Invdate: item?.INVDATE,
        ItemCode: "0",
        LASTBILLDATE: "-",
        LENGTH: null,
        LOOSEPCS: null,
        LQTY: null,
        OFFER_DIS: 0,
        OQTY2: 0,
        OQTY3: 0,
        OQTY4: null,
        PACKPCS: null,
        PNTMODEL: "-",
        PQTY: 0,
        PTYPE: item?.PTYPE,
        Partyname: item?.PARTYNAME,
        ProdName: item?.itemname,
        Prodsize: item?.PRODSIZE,
        Qty: item?.qty,
        RESELLERPRICE: null,
        RQTY: null,
        SEMIWSALERPRICE: null,
        SET_ITEMS: false,
        SGSTAMT: item?.SGSTAMT,
        SGSTRATE: item?.SGSTRATE,
        SLEVES: item?.SLEVES,
        SMODEL: "-",
        SMCODE: String(item?.SMCODE) ?? "",
        SNO: 0,
        TOKEN: item?.TOKEN,
        USTATUS: null,
        WPER: 0,
        WPRICE: 0,
        stock: item?.qty,
        cloud_upload: false,
        mesure: null,
        offer: item?.ITEM_ACTRATE,
        taans: false,
      }));
      if (response?.status === 200) {
        setUpdatedData(modifiedData);
        for (const item of modifiedData) {
          if (item.DesignCode) {
            await qtyAPI(item.DesignCode);
          }
        }
        setBarCodeData((prevData) => {
          const updatedData = [
            ...prevData,
            ...modifiedData.map((item) => {
              const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);
              let appliedGST = 0;
              if (gstItem?.ALLOWGSTVALUE === true) {
                const offerAmount = item.offer ?? 0;
                if (offerAmount <= gstItem.BELLOWVALUE) {
                  appliedGST = gstItem.BELLOWPER;
                } else if (offerAmount >= gstItem.ABOVEVALUE) {
                  appliedGST = gstItem.ABOVEPER;
                }
              } else {
                appliedGST = item?.GST;
              }
              return { ...item, GSTApplied: appliedGST };
            }),
          ];

          const totalBasic = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item.GSTApplied) || 0;
            const netAmt = qty * offer;
            return acc + netAmt * (100 / (100 + gst));
          }, 0);
          setTotalBasicAmount(totalBasic);

          const totalGst = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item.GSTApplied) || 0;
            const netAmt = qty * offer;
            const basic = netAmt * (100 / (100 + gst));
            return acc + basic * (gst / 100);
          }, 0);
          setTotalGstAmt(totalGst);

          const totalCGST = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item?.GSTApplied) || 0;
            const netAmt = qty * offer;
            const value = netAmt * (100 / (100 + gst));
            return acc + (value * (gst / 100)) / 2;
          }, 0);
          setTotalCGSTAmt(totalCGST);

          const totalSGST = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item?.GSTApplied) || 0;
            const netAmt = qty * offer;
            const value = netAmt * (100 / (100 + gst));
            return acc + (value * (gst / 100)) / 2;
          }, 0);
          setTotalSGSTAmt(totalSGST);

          const totalDis = updatedData.reduce(
            (acc, item) => acc + (Number(item.Disper) || 0),
            0,
          );
          setTotalDiscount(totalDis);
          const totalAmt = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            return acc + offer * qty;
          }, 0);
          setTotalAmount(totalAmt);
          const totDisAmt = updatedData.reduce(
            (acc, item) => acc + (Number(item.Disamt) || 0),
            0,
          );
          steTotalDisAmt(totDisAmt);
          const totGrossAmt = totalAmt - totDisAmt;
          setTotalGrossAmount(totGrossAmt);
          setTotalNetAmount(totGrossAmt);

          const gstGroupedMap = new Map();
          updatedData.forEach((item) => {
            const key = item.GSTApplied;
            const netAmt = item.stock * item.offer;
            const basicAmt = netAmt * (100 / (100 + key));
            const cgstRate = key / 2;
            const cgstAmt = (netAmt * (key / 100)) / 2;
            const sgstAmt = cgstAmt;
            if (!gstGroupedMap.has(key)) {
              gstGroupedMap.set(key, {
                GST: key,
                CGST_RATE: cgstRate,
                Basic_amt: 0,
                CGST_AMT: 0,
                SGST: cgstRate,
                SGST_AMT: 0,
                NET_AMT: 0,
              });
            }
            const existing = gstGroupedMap.get(key);
            existing.Basic_amt += basicAmt;
            existing.CGST_AMT += cgstAmt;
            existing.SGST_AMT += sgstAmt;
            existing.NET_AMT += netAmt;
          });
          setTotalGstData(Array.from(gstGroupedMap.values()));

          return updatedData;
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const modifyMastAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=RETURN_MAST&where=BILLNO=${no}`,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
      let data = response?.data;
      if (response?.status === 200) {
        userGetDetailsAPI(data[0]?.PhoneNo);
        setDisPer(data[0]?.DISPER);
        setTotalDiscountAmt(data[0]?.DISAMT);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const modifySalesDetAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=BILL_ITEMS_DET&where=BILLNO=${no} AND TYPE='B'`,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
      let data = response?.data;
      let offerARate = 0;
      let offerBRate = 0;
      for (const item of data) {
        if (item.STATION === "A") {
          offerARate = item.CESSPER;
        } else if (item.STATION === "B") {
          offerBRate = item.CESSPER;
        }
      }
      // setOfferARate(offerARate);
      // setOfferBRate(offerBRate);
      const modifiedData = data.map((item, index) => {
        return {
          ACITY: "-",
          AGENTNAME: "-",
          Area: item?.AREA,
          BOXES: item?.BOXES,
          BRANCHNAME: "-",
          CASERATECP: null,
          CASERATEDP: null,
          CASERATERP: null,
          CGSTAMT: item?.CGSTAMT,
          CGSTRATE: item?.CGSTRATE,
          COLOUR: item?.COLOUR,
          CPrice: item?.rate,
          CTOKEN: 0,
          Code: item?.code,
          CompName: item?.CompName,
          DPrice: item?.DPrice,
          DesignCode: item?.ITEMCODE,
          Disamt: item?.ITEM_DIS,
          Disper: item?.DISPER,
          ECODE: item?.ECODE,
          ENTRYDATE: "-",
          ENTRYNO: 0,
          EQTY: 0,
          EXPDATE: null,
          FITTING: item?.FITTING,
          FLOOR: item?.FLOOR,
          FYEAR: "-",
          GST: item?.GST,
          GSTAMT: item?.GSTAMT,
          GrosDPrice: item?.ITEM_ACTRATE,
          GroupName: item?.GroupName,
          HID: item?.HID,
          HSNCODE: item?.HSNCODE,
          ICODETYPE: "-",
          IGSTAMT: item?.IGSTAMT,
          IGSTRATE: item?.IGSTRATE,
          InvNO: item?.INVNO,
          Invdate: item?.INVDATE,
          ItemCode: "0",
          LASTBILLDATE: "-",
          LENGTH: null,
          LOOSEPCS: null,
          LQTY: null,
          OFFER_DIS: 0,
          OQTY2: Number(item?.PCSPRICE),
          OQTY3: Number(item?.CASEPRICE),
          OQTY4: null,
          PACKPCS: null,
          PNTMODEL: "-",
          PQTY: 0,
          PTYPE: item?.PTYPE,
          Partyname: item?.PARTYNAME,
          ProdName: item?.itemname,
          Prodsize: item?.PRODSIZE,
          Qty: item?.qty,
          RESELLERPRICE: null,
          RQTY: null,
          SEMIWSALERPRICE: null,
          SET_ITEMS: false,
          SGSTAMT: item?.SGSTAMT,
          SGSTRATE: item?.SGSTRATE,
          SLEVES: item?.SLEVES,
          SMODEL: item?.STATION,
          SMCODE: String(item?.SMCODE) ?? "",
          SNO: 0,
          TOKEN: item?.TOKEN,
          USTATUS: null,
          WPER: 0,
          WPRICE: 0,
          stock: item?.qty,
          cloud_upload: false,
          mesure: null,
          offer: item?.ITEM_ACTRATE,
          taans: false,
        };
      });

      if (response?.status === 200) {
        setUpdatedData(modifiedData);
        for (const item of modifiedData) {
          if (item.DesignCode) {
            await qtyAPI(item.DesignCode);
          }
        }
        setBarCodeData((prevData) => {
          const updatedData = [
            ...prevData,
            ...modifiedData.map((item) => {
              const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);
              let appliedGST = 0;
              if (gstItem?.ALLOWGSTVALUE === true) {
                const offerAmount = item.offer ?? 0;
                if (offerAmount <= gstItem.BELLOWVALUE) {
                  appliedGST = gstItem.BELLOWPER;
                } else if (offerAmount >= gstItem.ABOVEVALUE) {
                  appliedGST = gstItem.ABOVEPER;
                }
              } else {
                appliedGST = item?.GST;
              }
              return { ...item, GSTApplied: appliedGST };
            }),
          ];

          const totalBasic = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item.GSTApplied) || 0;
            const netAmt = qty * offer;
            return acc + netAmt * (100 / (100 + gst));
          }, 0);
          setTotalBasicAmount(totalBasic);

          const totalGst = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item.GSTApplied) || 0;
            const netAmt = qty * offer;
            const basic = netAmt * (100 / (100 + gst));
            return acc + basic * (gst / 100);
          }, 0);
          setTotalGstAmt(totalGst);

          const totalCGST = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item?.GSTApplied) || 0;
            const netAmt = qty * offer;
            const value = netAmt * (100 / (100 + gst));
            return acc + (value * (gst / 100)) / 2;
          }, 0);
          setTotalCGSTAmt(totalCGST);

          const totalSGST = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            const gst = Number(item?.GSTApplied) || 0;
            const netAmt = qty * offer;
            const value = netAmt * (100 / (100 + gst));
            return acc + (value * (gst / 100)) / 2;
          }, 0);
          setTotalSGSTAmt(totalSGST);

          const totalDis = updatedData.reduce(
            (acc, item) => acc + (Number(item.Disper) || 0),
            0,
          );
          setTotalDiscount(totalDis);

          const totalAmt = updatedData.reduce((acc, item) => {
            const offer = Number(item.offer) || 0;
            const qty = Number(item.stock) || 0;
            return acc + offer * qty;
          }, 0);
          setTotalAmount(totalAmt);

          const totDisAmt = updatedData.reduce(
            (acc, item) => acc + (Number(item.Disamt) || 0),
            0,
          );
          steTotalDisAmt(totDisAmt);

          const totGrossAmt = totalAmt - totDisAmt;
          setTotalGrossAmount(totGrossAmt);
          setTotalNetAmount(totGrossAmt);

          const gstGroupedMap = new Map();
          updatedData.forEach((item) => {
            const key = item.GSTApplied;
            const netAmt = item.stock * item.offer;
            const basicAmt = netAmt * (100 / (100 + key));
            const cgstRate = key / 2;
            const cgstAmt = (netAmt * (key / 100)) / 2;
            const sgstAmt = cgstAmt;
            if (!gstGroupedMap.has(key)) {
              gstGroupedMap.set(key, {
                GST: key,
                CGST_RATE: cgstRate,
                Basic_amt: 0,
                CGST_AMT: 0,
                SGST: cgstRate,
                SGST_AMT: 0,
                NET_AMT: 0,
              });
            }
            const existing = gstGroupedMap.get(key);
            existing.Basic_amt += basicAmt;
            existing.CGST_AMT += cgstAmt;
            existing.SGST_AMT += sgstAmt;
            existing.NET_AMT += netAmt;
          });
          setTotalGstData(Array.from(gstGroupedMap.values()));

          return updatedData;
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const modifySalesMastAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CREDIT_BILLMAST&where=BILLNO=${no}`,
        {
          headers: {
            "Content-Type": "application/json",
            tenantName: tenantName,
          },
        },
      );
      let data = response?.data;
      if (response?.status === 200) {
        userGetDetailsAPI(data[0]?.PhoneNo);
        setDisPer(data[0]?.DISPER);
        setTotalDiscountAmt(data[0]?.DISAMT);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const modifySaleBillOnlineAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=ORG_CARDDET&where=BILLNO=${no} AND STYPE='BILLING'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        if (data[0]?.PTYPE === "CARD") {
          setCashValue("CARD");
          setCardAmt(data[0]?.AMT);
        } else if (data[0]?.PTYPE === "UPI") {
          setCashValue("UPI");
          setUpiAmt(data[0]?.AMT);
        } else if (data[0]?.PTYPE === "ONLINE") {
          setCashValue("ONLINE");
          setOnlineAmt(data[0]?.AMT);
        } else {
          setCashValue("CASH");
        }
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const modifySaleBillOpeningLedgerAPI = async (no) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=TRANS_ENTRY_DATA_CUST&where=ENTRYNO=${no} AND SALESTYPE='BILLING'`,
        { headers: { tenantName: tenantName } },
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        if (data[0]?.NAMA > 0) {
          setCashValue("CREDIT");
          setCreditAmt(data[0]?.NAMA);
        }
        userGetDetailsAPI(data[0]?.AGENTNAME);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const deleteBarcodeMastAPI = async () => {
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=RETURN_MAST&where=BILLNO=${billNo}`,
        {},
        { headers: { tenantName: tenantName } },
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message,
      );
    }
  };

  const deleteBarcodeDetAPI = async () => {
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=RETURN_DATA&where=BILLNO=${billNo}`,
        {},
        { headers: { tenantName: tenantName } },
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message,
      );
    }
  };

  const deleteBarcodePayModeAPI = async () => {
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=SINGLE_ENTRY_DATA&where=ENTRYNO=${billNo}`,
        {},
        { headers: { tenantName: tenantName } },
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message,
      );
    }
  };

  const deleteBarcodeOnlinePayAPI = async () => {
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=ORG_CARDDET&where=BILLNO=${billNo}`,
        {},
        { headers: { tenantName: tenantName } },
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message,
      );
    }
  };

  const deleteBarcodeLedgerAPI = async () => {
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=TRANS_ENTRY_DATA_CUST&where=ENTRYNO=${billNo}`,
        {},
        { headers: { tenantName: tenantName } },
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message,
      );
    }
  };

  const deleteCustomerDetailsAPI = async (mobile) => {
    try {
      await axios.post(
        `${CREATE_jwel}/api/ERP/DeleteDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=MOBILENO='${mobile}'`,
        {},
        { headers: { tenantName: tenantName } },
      );
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message,
      );
    }
  };

  const handleDelete = (indexToDelete) => {
    smCodeRef.current?.focus();
    setBarCodeData((prevData) => {
      const updatedData = [...prevData];
      updatedData.splice(indexToDelete, 1);
      return updatedData;
    });
    setCashValue("CASH");
    setCashAmt(totalNetAmount);
    setUpiAmt(0);
    setCardAmt(0);
    setOnlineAmt(0);
    setCreditAmt(0);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "sno",
      key: "sno",
      width: 80,
      align: "center",
      render: (_, __, index) => <span className="si-sno">{index + 1}</span>,
    },
    {
      title: "Sm Code",
      dataIndex: "SMCODE",
      key: "SMCODE",
      width: 120,
      render: (text) => (
        <strong className="si-sm-badge">
          {text === null || text === undefined || text === "" || text === "-"
            ? ""
            : text}
        </strong>
      ),
    },
    {
      key: "actions",
      align: "left",
      width: 70,
      className: "col-divider",
      render: (_, record, index) => (
        <div className="si-row-actions">
          <ItemDetailsPopover record={record} smCodeRef={smCodeRef} />
          {adminType === "ADMIN" || (adminType === "OPERATOR" && !billNo) ? (
            <Popconfirm
              title="Are you sure you want to delete?"
              onConfirm={() => {
                smCodeRef.current?.focus();
                handleDelete(index);
              }}
              onCancel={() => smCodeRef.current?.focus()}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="link"
                danger
                icon={<DeleteOutlined />}
                style={{ fontSize: "16px", padding: 0 }}
              />
            </Popconfirm>
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      title: "Design Code",
      dataIndex: "DesignCode",
      key: "DesignCode",
      width: 150,
      render: (value) => <span className="si-design-badge">{value}</span>,
    },
    {
      title: "Particulars",
      dataIndex: "ProdName",
      key: "ProdName",
      width: 220,
      render: (text) => {
        const shouldTooltip = text && text.length > 15;
        return shouldTooltip ? (
          <Tooltip title={text}>
            <span style={{ fontSize: "12px", color: "#4b5563" }}>
              {text.substring(0, 15)}...
            </span>
          </Tooltip>
        ) : (
          <span style={{ fontSize: "12px", color: "#4b5563" }}>{text}</span>
        );
      },
    },
    {
      title: "QTY",
      dataIndex: "stock",
      align: "center",
      key: "stock",
      width: 100,
      className: "col-divider",
      render: (_, record, index) => (
        <div
          onClick={() => {
            if (
              adminType === "ADMIN" ||
              (adminType === "OPERATOR" && !billNo)
            ) {
              setItemDetailsOpen(true);
              setItemDetailsData(record);
              setItemDEsignCode(index);
            }
            smCodeRef.current?.focus();
          }}
          style={{ cursor: "pointer" }}
        >
          <span className="si-qty-badge">
            {Number(record?.stock)?.toFixed(2)}
          </span>
        </div>
      ),
    },
    {
      title: "Rate",
      dataIndex: "CPrice",
      align: "right",
      key: "CPrice",
      width: 120,
      render: (_, record, index) => (
        <div
          onClick={() => {
            if (
              adminType === "ADMIN" ||
              (adminType === "OPERATOR" && !billNo)
            ) {
              setItemDetailsOpen(true);
              setItemDetailsData(record);
              setItemDEsignCode(index);
            }
            smCodeRef.current?.focus();
          }}
          style={{ cursor: "pointer" }}
        >
          <span style={{ fontSize: "13px", fontWeight: 600, color: "#374151" }}>
            {Number(record?.CPrice)?.toFixed(2)}
          </span>
        </div>
      ),
    },
    {
      title: "Dis(%)",
      dataIndex: "Disper",
      align: "right",
      key: "Disper",
      width: 130,
      render: (_, record, index) => (
        <div
          onClick={() => {
            if (
              adminType === "ADMIN" ||
              (adminType === "OPERATOR" && !billNo)
            ) {
              setItemDetailsOpen(true);
              setItemDetailsData(record);
              setItemDEsignCode(index);
            }
            smCodeRef.current?.focus();
          }}
          style={{ cursor: "pointer" }}
        >
          <span style={{ fontSize: "13px", color: "#1d4ed8" }}>
            {Number(record?.Disper)}
          </span>
        </div>
      ),
    },
    {
      title: "Dis.Amt",
      dataIndex: "Disamt",
      align: "right",
      key: "Disamt",
      width: 150,
      render: (_, record, index) => (
        <div
          onClick={() => {
            if (
              adminType === "ADMIN" ||
              (adminType === "OPERATOR" && !billNo)
            ) {
              setItemDetailsOpen(true);
              setItemDetailsData(record);
              setItemDEsignCode(index);
            }
            smCodeRef.current?.focus();
          }}
          style={{ cursor: "pointer" }}
        >
          <span style={{ fontSize: "13px" }}>
            {Number(record?.Disamt)?.toFixed(2)}
          </span>
        </div>
      ),
    },
    {
      title: "Act.Rate",
      dataIndex: "offer",
      align: "right",
      key: "offer",
      width: 150,
      className: "col-divider",
      render: (_, record, index) => (
        <div
          onClick={() => {
            if (
              adminType === "ADMIN" ||
              (adminType === "OPERATOR" && !billNo)
            ) {
              setItemDetailsOpen(true);
              setItemDetailsData(record);
              setItemDEsignCode(index);
            }
            smCodeRef.current?.focus();
          }}
          style={{ cursor: "pointer" }}
        >
          <span style={{ fontSize: "13px", fontWeight: 600 }}>
            {Number(record?.offer)?.toFixed(2)}
          </span>
        </div>
      ),
    },
    {
      title: "Amount",
      className: "blue-background-column",
      dataIndex: "stock",
      align: "right",
      key: "amount",
      width: 150,
      render: (_, record) => (
        <span className="si-amount-badge">
          {Number(record?.stock * record.offer)?.toFixed(2)}
        </span>
      ),
    },
  ];

  useEffect(() => {
    invNoAPI();
    commissionAPI();
    gstCheckAPI();
    userAPI();
    onlineAccNoAPI();
    holdNoAPI();
    holdMastNoAPI();
  }, []);

  useEffect(() => {
    const disAmt = barCodeData.reduce((acc, item) => {
      const dis = Number(item.Disamt) || 0;
      const qty = Number(item.stock) || 0;
      return acc + dis * qty;
    }, 0);
    const qty = barCodeData.reduce(
      (sum, item) => sum + (parseFloat(item.stock) || 0),
      0,
    );
    const totalAmt = barCodeData.reduce((acc, item) => {
      const offer = Number(item.CPrice) || 0;
      const qty = Number(item.stock) || 0;
      return acc + offer * qty;
    }, 0);
    const grossAmt = totalAmt - disAmt;
    const discountPer = grossAmt * disPer;
    const disCountAmt = discountPer / 100;
    const netAmount = grossAmt - disCountAmt;
    const netAmt = grossAmt - totalDiscountAmt;
    const overalAmount = disCountAmt > 0 ? netAmount : (netAmt ?? 0);
    steTotalDisAmt(disAmt);
    setTotalQty(qty);
    setTotalAmount(totalAmt);
    setTotalGrossAmount(grossAmt);
    setTotalNetAmount(overalAmount);
    setCashAmt(overalAmount);
  }, [barCodeData, disPer]);

  const handleTagNoKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submitRef.current?.click();
    }
  };
  const handleSmCodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      smSubmitRef.current?.click();
    }
  };
  const handleEstNoKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      fetchRef.current?.click();
    }
  };
  const handleMobileNoKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      searchRef.current?.click();
    }
  };

  const filterDataByHoldNo = (value) => {
    if (value === "" || value === null || value === undefined) {
      setHNo();
      setSelectedHoldRowKeys([]);
      setFilteredHoldData(holdData);
      return;
    }
    const num = Number(value);
    const filtered = holdData.filter((item) => item.billno === num);
    setFilteredHoldData(filtered);
    const exactMatch = holdData.find((item) => item.billno === num);
    setSelectedHoldRowKeys(exactMatch ? [exactMatch.billno] : []);
  };

  const handleSearchHoldInput = (e) => {
    const value = e.target.value;
    if (value === "0") return;
    if (value.startsWith("0")) return;
    setSearchHoldText(value);
    filterDataByHoldNo(value);
  };

  const handleCheckboxChangeHold = (billNo) => {
    const isSelected = selectedHoldRowKeys.includes(billNo);
    const newKeys = isSelected ? [] : [billNo];
    const text = newKeys.join(", ");
    setSelectedHoldRowKeys(newKeys);
    setSearchHoldText(text);
    setHNo(text);
    filterDataByHoldNo(text);
  };

  useEffect(() => {
    if (smCodeData && smCodeData.length > 0) {
      tagNoRef.current?.focus();
    }
  }, [smCodeData]);

  const fetchWithRetry = async (url, retries = 3, delay = 300) => {
    for (let i = 0; i < retries; i++) {
      try {
        const res = await fetch(url, { mode: "cors" });
        if (res.ok) return res;
      } catch (e) {
        console.warn(`Retry ${i + 1} for ${url}`);
      }
      await new Promise((r) => setTimeout(r, delay));
    }
    throw new Error("Failed after retries: " + url);
  };

  const resizeBase64Img = (base64Str, maxWidth = 500, maxHeight = 500) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        let width = img.width;
        let height = img.height;
        if (width > maxWidth || height > maxHeight) {
          if (width / height > maxWidth / maxHeight) {
            height *= maxWidth / width;
            width = maxWidth;
          } else {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.src = base64Str;
    });

  const urlToBase64 = async (url) => {
    const cleanUrl = decodeURIComponent(url);
    const proxyUrl = `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(cleanUrl)}`;
    const response = await fetchWithRetry(proxyUrl, 3, 800);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        try {
          const resized = await resizeBase64Img(reader.result);
          resolve(resized);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  useEffect(() => {
    if (!totalNetAmount) return;
    const canvas = qrRef.current?.querySelector("canvas");
    if (canvas) {
      const base64 = canvas.toDataURL("image/png");
      setBase64QR(base64);
    }
  }, [totalNetAmount, upiLink]);

  const custTypeData = [{ CUSTTYPE: "RETAIL" }, { CUSTTYPE: "WHOLESALE" }];

  useEffect(() => {
    const convertImage = async () => {
      const imageUrl = logoImage;
      try {
        const base64 = await urlToBase64(imageUrl);
        setBase64Images(base64);
      } catch (err) {
        console.error("Image conversion failed:", err);
      }
    };
    convertImage();
  }, [logoImage]);

  const handleInvoicePdfDownload = async (nextInvNo) => {
    const element = document.createElement("div");
    const logoSrc = base64Images;
    const sharedStyles = `
    <style>
      table { width: 100%; border-collapse: collapse; border: 1px solid black; font-family: Arial, sans-serif; font-size: 9px; }
      th, td { border: 1px solid black; padding: 3px; text-align: center; vertical-align: middle; }
      th { font-weight: bold; background-color: #162566; font-size: 12px; height: 30px; color: white; }
      td strong { font-size: 10px; }
      td span { font-size: 10px; }
      .sub { text-align: left; padding: 5px 5px; }
      .sub-name { text-align: center; font-size: 9px; border: 1px solid White; }
      .sub-qty { text-align: center; font-size: 9px; border: 1px solid White; }
      .sub-right { text-align: right; width: 60px; }
      .sub-right1 { text-align: right; width: 60px; line-height: 1.2; }
      .sub-right2 { text-align: right; }
      .sub-amount { text-align: right; width: 70px; background-color: #c5dfe8ff; }
      .sub-qtys { text-align: center; width: 30px; background-color: #d3e8f0ff; }
      .sub-no { text-align: center; font-size: 10px; width: 40px; background-color: #d3e8f0ff; }
      .sub-all { text-align: center; width: 60px; font-size: 9px; border: 1px solid White; }
      .sub-amounts { text-align: center; width: 70px; font-size: 9px; border: 1px solid White; }
      .sub-sno { text-align: center; font-size: 10px; width: 40px; border: 1px solid White; }
      td div.sub-text { text-align: left; font-size: 8px; font-weight: bold; }
      td div.sub-code { font-size: 10px; font-weight: bold; background-color: #52bd91; border: 1px solid #52bd91; border-radius: 4px; padding: 4px 5px 3px 5px; display: inline-block; color: white; }
      td div.sub-hsn { display: inline-block; font-size: 9px; margin-left: 30px; }
      tr.sub-row td { border-top: none; text-align: left; }
    </style>`;
    const logoHtml = logoSrc
      ? `<img src="${logoSrc}" alt="TLogo" style="width: 200px; height: 200px; object-fit: contain; display: block; margin-bottom: 5px;">`
      : "";
    const showValue = (val) =>
      val && val !== "-" && String(val).trim() !== "" && val !== "undefined"
        ? val
        : "-";
    const isValidValueLocal = (val) =>
      val !== null &&
      val !== undefined &&
      val !== "-" &&
      String(val).trim() !== "" &&
      val !== "undefined";
    const totals = totalGstData.reduce(
      (acc, row) => {
        acc.Basic_amt += row.Basic_amt;
        acc.CGST_AMT += row.CGST_AMT;
        acc.SGST_AMT += row.SGST_AMT;
        acc.NET_AMT += row.NET_AMT;
        return acc;
      },
      { Basic_amt: 0, CGST_AMT: 0, SGST_AMT: 0, NET_AMT: 0 },
    );
    const tableBodyHTML =
      totalGstData
        .map(
          (row) => `
  <tr>
    <td style="border: 1px solid black; text-align: left;">${row.Basic_amt.toFixed(2)}</td>
    <td style="border: 1px solid black; text-align: right;">${row.CGST_RATE}%</td>
    <td style="border: 1px solid black; text-align: right;">${row.CGST_AMT.toFixed(2)}</td>
    <td style="border: 1px solid black; text-align: right;">${row.SGST}%</td>
    <td style="border: 1px solid black; text-align: right;">${row.SGST_AMT.toFixed(2)}</td>
    <td style="border: 1px solid black; text-align: right;">${row.NET_AMT.toFixed(2)}</td>
  </tr>`,
        )
        .join("") +
      `
  <tr>
    <td style="border: 1px solid black; text-align: left; font-weight: bold;">${totals.Basic_amt.toFixed(2)}</td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.CGST_AMT.toFixed(2)}</td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.SGST_AMT.toFixed(2)}</td>
    <td style="border: 1px solid black; text-align: right; font-weight: bold;">${totals.NET_AMT.toFixed(2)}</td>
  </tr>`;
    const content = `
    ${sharedStyles}
   <div style="margin: 0; font-family: Arial, sans-serif; font-size: 10px; display: flex; justify-content: center;">
  <div style="width: 90mm; margin: 0 auto; padding-left: 5mm; padding-right: 5mm; box-sizing: border-box;">
      <div style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center; margin-bottom: 5px; margin-top: 15px;">
  ${logoHtml}
  <h2 style="margin: 0; font-size: 12px; font-weight: bold;">${address}</h2>
  <h2 style="margin: 0; font-size: 12px; font-weight: bold;">${address1}</h2>
  <h2 style="margin: 0; font-size: 12px; font-weight: bold;">${city}</h2>
  ${isValidValueLocal(gstNo) ? `<h2 style="margin: 0; font-size: 12px; font-weight: bold;">${gstNo}</h2>` : ""}
  <h2 style="margin: 0; font-size: 12px; font-weight: bold;">PHONE NO: ${showValue(userPhone)}</h2>
</div>
      <div style="border: 1px solid black; margin-top: 5px; font-size: 9px; padding: 0;">
        <div style="display: flex; justify-content: center; align-items: center; background-color: #162566; height: 30px; border-bottom: 1px solid black;">
          <div style="flex: 1; font-size: 12px; color: white; text-align: center; font-weight: bold; padding: 3px;">SALE RETURN</div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1; padding: 5px 8px;">
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Invoice No</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 14px; font-weight: bold; color: red;">#${billNo ? billNo : nextInvNo}</div>
            </div>
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Invoice Date</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 12px; font-weight: bold;">${billDate
        ? dayjs(billDate).format("DD-MMM-YYYY hh:mm A")
        : dayjs().format("DD-MMM-YYYY hh:mm A")
      }</div>
            </div>
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Customer</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 12px; font-weight: bold;">${showValue(userDetails?.Custname)}</div>
            </div>
            <div style="display: flex; font-size: 12px; margin-bottom: 5px;">
              <div style="width: 90px;">Contact</div><div style="width: 10px; font-weight: bold;">:</div>
              <div style="font-size: 12px; font-weight: bold;">${showValue(userDetails?.Mobileno)}</div>
            </div>
          </div>
        </div>
      </div>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; font-family: Arial, sans-serif; font-size: 9px; margin-top: 5px;">
        <thead>
          <tr>
            <th class="sub-sno">SNo</th><th class="sub-name">PARTICULARS</th><th class="sub-qty">QTY</th><th class="sub-all">RATE</th>
          <th class="sub-all">DISC</th><th class="sub-amounts">AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          ${barCodeData
        .map((item, index) => {
          const removeUndefinedWrapper = (str) =>
            str.replace(/undefined\(\s*(.*?)\s*\)/g, "$1").trim();
          const cleanedActGrams = removeUndefinedWrapper(item.HSNCODE);
          const cleanedCode = removeUndefinedWrapper(item.DesignCode);
          const subRow = cleanedActGrams
            ? `
              <tr class="sub-row">
  <td colspan="4">
    <div class="sub-text">
      <div class="sub-code">${cleanedCode}</div>
      <div class="sub-hsn">HSN: ${cleanedActGrams}</div>
    </div>
  </td>
</tr>`
            : "";
          return `
                <tr>
                <td class="sub-no" rowspan="${cleanedActGrams && cleanedCode ? 2 : 1}"><strong>${index + 1}</strong></td>
                  <td class="sub">${item.ProdName}</td>
        <td class="sub-qtys">${item.stock}</td>
        <td class="sub-right">${item.CPrice.toFixed(2)}</td>
        <td class="sub-right1">
        ${item.Disamt.toFixed(2)}
        ${item.Disper > 0 ? `<div class="sub-right2">${Number(item.Disper)?.toFixed(2)}%</div>` : ""}
        </td>
        <td class="sub-amount" rowspan="${cleanedActGrams && cleanedCode ? 2 : 1}"><strong>${Number(item.stock * item.offer).toFixed(2)}</strong></td>
                </tr>
                ${subRow}`;
        })
        .join("")}
        </tbody>
      </table>
      <div style="font-size: 10px; margin-top: 5px;">
      <div style="border: 1px solid #141414ff; font-size: 12px; font-family: Arial, sans-serif;">
  <div style="padding: 8px;">
    <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
      <span style="flex: 1;">Total Amount</span>
      <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
      <span style="flex: 1; text-align: right;">${totalAmount.toFixed(2)}</span>
    </div>
    <div style="display: flex; justify-content: space-between;">
      <span style="flex: 1;">Discount</span>
      <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
      <span style="flex: 1; text-align: right;">${totalDiSAmt.toFixed(2)}</span>
    </div>
  </div>
  <div style="background-color: #52bd91; font-weight: bold; display: flex; align-items: center; padding: 8px; border-top: 1px solid #0d0d0eff;">
    <div style="flex: 1; display: flex; align-items: center;">
      <span style="color: red; font-size: 14px; margin-right: 6px;">&#10148;</span>
      <span>Net Amount</span>
    </div>
    <span style="flex: 0 0 10px; text-align: center; font-weight: bold;">:</span>
    <div style="flex: 1; text-align: right; font-size: 16px; color: white;">${totalNetAmount?.toFixed(2)}</div>
  </div>
</div>
      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 5px; font-weight: bold;">
        <div style="display: flex; align-items: center;">
          <span style="color: red; font-size: 14px; margin-right: 6px;">&#10148;</span> <span style:"font-size: 14px; font-weight: bold;">Total Qty :</span>
          <span style="border: 1px solid #52bd91; padding: 5px 8px 5px 8px; margin-left: 5px; font-size: 14px; border-radius: 4px; background-color: #52bd91;">${totalQty}</span>
        </div>
        <div>RE-PRINT</div>
      </div>
       ${gstValue === true && totalGstData.length > 0
        ? `
      <table style="width: 100%; border-collapse: collapse; font-size: 10px; margin-top: 10px;">
        <thead style:"height: 50px; background-color: #a9f0d2ff;">
    <tr>
      <th rowspan="2" style="border: 1px solid white; text-align: center; vertical-align: middle; font-size: 8px; height: 10px;">BASIC AMOUNT</th>
      <th colspan="2" style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">CENTRAL TAX</th>
      <th colspan="2" style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">STATE TAX</th>
      <th rowspan="2" style="border: 1px solid white; text-align: center; vertical-align: middle; font-size: 8px; height: 10px;">NET AMT</th>
    </tr>
    <tr>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">(%)</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">CGST</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">(%)</th>
      <th style="border: 1px solid white; text-align: center; font-size: 8px; height: 10px;">SGST</th>
    </tr>
  </thead>
        <tbody>
          ${tableBodyHTML}
        </tbody>
      </table>`
        : ""
      }
      <div style="margin-top: 10px; font-size: 9px; padding-top: 5px; text-align: center;">
        <span style="font-size: 14px;">Terms & Conditions</span>
        <ul style="text-align: left; margin-top: 5px;">
          <li style="margin-bottom: 5px;">${ins}</li>
          <li style="margin-bottom: 5px;">${ins1}</li>
          <li style="margin-bottom: 5px;">${ins2}</li>
          <li style="margin-bottom: 5px;">${ins3}</li>
          <li style="margin-bottom: 5px;">${ins4}</li>
          <li style="margin-bottom: 5px;">${ins5}</li>
          <li style="margin-bottom: 5px;">${ins6}</li>
        </ul>
      </div>
        <div style="background-color: #add8e6; display: flex; justify-content: center; align-items: center; padding: 8px; border-radius: 10px;">
    <div style=" display: flex; justify-content: center; align-items: center; font-size: 12px; font-family: Times New Roman;">
      Thank you, please visit again!
    </div>
  </div>
    </div>
  </div>
  `;
    element.innerHTML = content;
    const opt = {
      margin: [0, 5, 0, 5],
      filename: `Return-${billNo || nextInvNo}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: [90, 297], orientation: "portrait" },
    };
    html2pdf().from(element).set(opt).save();
  };

  const handleBillPrint = (nextInvNo) => {
    BillPdfDownload(
      userDetails,
      userPhone,
      address,
      address1,
      gstNo,
      nextInvNo,
      billNo,
      billDate,
      userName,
      barCodeData,
      totalAmount,
      totalDiSAmt,
      totalNetAmount,
      totalQty,
      base64Images,
      base64QR,
      totalGstData,
      ins,
      ins1,
      ins2,
      ins3,
      ins4,
      ins5,
      ins6,
      gstValue,
      cashAmt,
      cardAmt,
      onlineAmt,
      upiAmt,
      creditAmt,
    );
  };

  const handleEposPrint = (nextInvNo) => {
    printReceipt(
      localIp,
      userDetails,
      userPhone,
      address,
      address1,
      gstNo,
      nextInvNo,
      billNo,
      userName,
      barCodeData,
      totalAmount,
      totalDiSAmt,
      totalNetAmount,
      totalQty,
      base64Images,
      base64QR,
      totalGstData,
      ins,
      ins1,
      ins2,
      ins3,
      ins4,
      ins5,
      ins6,
    );
  };

  const handleHomeBillSave = () => {
    if (Number(qty) === 0) {
      message.open({
        type: "error",
        content: <div style={{ fontSize: "20px" }}>Check Quantity</div>,
      });
      return;
    }
    const homeData = [
      {
        ACITY: "-",
        AGENTNAME: "-",
        Area: "-",
        BOXES: null,
        BRANCHNAME: "-",
        CASERATECP: null,
        CASERATEDP: null,
        CASERATERP: null,
        CGSTAMT: 0,
        CGSTRATE: 0,
        COLOUR: "-",
        CPrice: rate,
        CTOKEN: 0,
        Code: "-",
        CompName: brandName,
        DPrice: 0,
        DesignCode: designCode,
        Disamt: disAmt,
        Disper: disCount,
        ECODE: "-",
        ENTRYDATE: "-",
        ENTRYNO: 0,
        EQTY: 0,
        EXPDATE: null,
        FITTING: "-",
        FLOOR: "-",
        FYEAR: "-",
        GST: 0,
        GSTAMT: 0,
        GrosDPrice: 0,
        GroupName: "-",
        HID: 0,
        HSNCODE: hsnCode,
        ICODETYPE: "-",
        IGSTAMT: 0,
        IGSTRATE: 0,
        InvNO: "-",
        Invdate: "-",
        ItemCode: "0",
        LASTBILLDATE: "-",
        LENGTH: null,
        LOOSEPCS: null,
        LQTY: null,
        OFFER_DIS: 0,
        OQTY2: 0,
        OQTY3: 0,
        OQTY4: null,
        PACKPCS: null,
        PNTMODEL: "-",
        PQTY: 0,
        PTYPE: pTypeName,
        Partyname: "-",
        ProdName: productName,
        Prodsize: "-",
        Qty: qty,
        RESELLERPRICE: null,
        RQTY: null,
        SEMIWSALERPRICE: null,
        SET_ITEMS: false,
        SGSTAMT: 0,
        SGSTRATE: 0,
        SLEVES: "-",
        SMODEL: "-",
        SNO: 0,
        TOKEN: 0,
        USTATUS: null,
        WPER: 0,
        WPRICE: 0,
        stock: qty,
        cloud_upload: false,
        mesure: null,
        offer: amount,
        taans: false,
      },
    ];
    setHomeDetailsOpen(false);
    setQty(0);
    setAmount(0);
    setDisCount(0);
    setRate(0);
    setDisAmt(0);
    setProductName("");
    setDesignCode("");
    setPTypeName("");
    setHsnCode("");
    setBrandName("");
    setProductData([]);
    setBarCodeData((prevData) => {
      let updatedData = [...prevData];
      const newItems = homeData.map((item) => {
        const gstItem = gstData.find((gst) => gst.PType === item.PTYPE);
        let appliedGST = 0;
        if (gstItem) {
          const offerAmount = item.offer ?? 0;
          if (offerAmount <= gstItem.BELLOWVALUE) {
            appliedGST = gstItem.BELLOWPER;
          } else if (offerAmount >= gstItem.ABOVEVALUE) {
            appliedGST = gstItem.ABOVEPER;
          }
        }
        return {
          ...item,
          GSTApplied: appliedGST,
          SMCODE: smCodeData[0]?.CODE ?? "",
        };
      });
      newItems.forEach((newItem) => {
        if (newItem.stock > newItem.Qty) {
          message.open({
            type: "error",
            content: (
              <div style={{ fontSize: "18px" }}>
                Stock exceeded for Design Code {newItem.DesignCode}
              </div>
            ),
          });
          return;
        }
        updatedData.push(newItem);
      });

      const totalBasic = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        return acc + netAmt * (100 / (100 + gst));
      }, 0);
      setTotalBasicAmount(totalBasic);

      const totalGst = updatedData.reduce((acc, item) => {
        const offer = Number(item.offer) || 0;
        const qty = Number(item.stock) || 0;
        const gst = Number(item.GSTApplied) || 0;
        const netAmt = qty * offer;
        const basic = netAmt * (100 / (100 + gst));
        return acc + basic * (gst / 100);
      }, 0);
      setTotalGstAmt(totalGst);
      setTotalCGSTAmt(totalGst / 2);
      setTotalSGSTAmt(totalGst / 2);

      const totalAmt = updatedData.reduce(
        (acc, item) =>
          acc + (Number(item.offer) || 0) * (Number(item.stock) || 0),
        0,
      );
      setTotalAmount(totalAmt);

      const totalDisAmt = updatedData.reduce(
        (acc, item) => acc + (Number(item.Disamt) || 0),
        0,
      );
      steTotalDisAmt(totalDisAmt);

      const grossAmt = totalAmt - totalDisAmt;
      setTotalGrossAmount(grossAmt);
      setTotalNetAmount(grossAmt);

      const gstGroupedMap = new Map();
      updatedData.forEach((item) => {
        const key = item.GSTApplied;
        const netAmt = item.stock * item.offer;
        const basicAmt = netAmt * (100 / (100 + key));
        const gstAmt = (netAmt * (key / 100)) / 2;
        if (!gstGroupedMap.has(key)) {
          gstGroupedMap.set(key, {
            GST: key,
            CGST_RATE: key / 2,
            Basic_amt: 0,
            CGST_AMT: 0,
            SGST: key / 2,
            SGST_AMT: 0,
            NET_AMT: 0,
          });
        }
        const row = gstGroupedMap.get(key);
        row.Basic_amt += basicAmt;
        row.CGST_AMT += gstAmt;
        row.SGST_AMT += gstAmt;
        row.NET_AMT += netAmt;
      });
      setTotalGstData(Array.from(gstGroupedMap.values()));

      return updatedData;
    });
  };

  const handleReset = () => {
    window.location.reload();
    smCodeRef.current?.focus();
    invNoAPI();
    commissionAPI();
    setCardAcc("");
    setUpiAcc("");
    setOnlineAcc("");
    setGstData([]);
    setTotalGstData([]);
    setBarCodeData([]);
    setDesignData([]);
    setTotalGstAmt(0);
    setTotalCGSTAmt(0);
    setTotalSGSTAmt(0);
    setTotalDiscount(0);
    setTotalAmount(0);
    steTotalDisAmt(0);
    setTotalGrossAmount(0);
    setTotalNetAmount(0);
    setDisPer(0);
    setTotalDiscountAmt(0);
    setTotalAdjust(0);
    setTotalQty(0);
    setSmCode("");
    setSmCodeData([]);
    setCashValue("CASH");
    setCashAmt(0);
    setCardAmt(0);
    setUpiAmt(0);
    setOnlineAmt(0);
    setCreditAmt(0);
    setUserArea();
    setUserName();
    setSingleImage();
    setGstNo("");
    setUserPhone();
    setConditions("");
    setIns("");
    setIns1("");
    setIns2("");
    setIns3("");
    setIns4("");
    setIns5("");
    setIns6("");
    setAddress("");
    setAddress1("");
    setCity("");
    setTagNo();
    setEstNo();
    setSelectJewelType("RETAIL");
    setBillNo();
    setUserDetails({});
    setPhoneNo();
    setSearchText("");
    setItemDetailsData({});
    setItemDEsignCode();
    setPrvBalance(0);
    setSearchHoldText();
    holdMastNoAPI();
    setUpdatedData([]);
    setTotalBasicAmount(0);
    userAPI();
  };

  const handleRestore = () => {
    smCodeRef.current?.focus();
    invNoAPI();
    commissionAPI();
    setCardAcc("");
    setUpiAcc("");
    setOnlineAcc("");
    setGstData([]);
    setTotalGstData([]);
    setBarCodeData([]);
    setDesignData([]);
    setTotalGstAmt(0);
    setTotalCGSTAmt(0);
    setTotalSGSTAmt(0);
    setTotalDiscount(0);
    setTotalAmount(0);
    steTotalDisAmt(0);
    setTotalGrossAmount(0);
    setTotalNetAmount(0);
    setDisPer(0);
    setTotalDiscountAmt(0);
    setTotalAdjust(0);
    setTotalQty(0);
    setSmCode("");
    setSmCodeData([]);
    setCashValue("CASH");
    setCashAmt(0);
    setCardAmt(0);
    setUpiAmt(0);
    setOnlineAmt(0);
    setCreditAmt(0);
    setUserArea();
    setUserName();
    setSingleImage();
    setGstNo("");
    setUserPhone();
    setConditions("");
    setIns("");
    setIns1("");
    setIns2("");
    setIns3("");
    setIns4("");
    setIns5("");
    setIns6("");
    setAddress("");
    setAddress1("");
    setCity("");
    setTagNo();
    setEstNo();
    setSelectJewelType("RETAIL");
    setBillNo();
    setUserDetails({});
    setPhoneNo();
    setSearchText("");
    setItemDetailsData({});
    setItemDEsignCode();
    setPrvBalance(0);
    setSearchHoldText();
    holdMastNoAPI();
    setUpdatedData([]);
    setTotalBasicAmount(0);
    userAPI();
  };

  const handleQrcodeOpen = () => {
    setQrCodeOpen(true);
  };

  const handleQrcodeCancel = () => {
    setQrCodeOpen(false);
    smCodeRef.current?.focus();
  };

  const fetchStationInfo = async () => {
    try {
      const sysInfoRes = await axios.get(
        "http://localhost:5445/api/print/system-info",
      );
      const systemName = sysInfoRes.data?.systemName;

      if (!systemName) {
        console.warn("system-info did not return a systemName");
        return;
      }

      const configRes = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=COUNTER_CONFIG&where=SYSNAME='${systemName}'`,
        { headers: { tenantName } },
      );

      const configData = configRes.data;

      if (Array.isArray(configData) && configData.length > 0) {
        setThermalPrinter(configData[0]?.BILLINGPRINTER || "");
        setThermalPrinterDetails(configData[0]);
      } else {
        console.warn(`No COUNTER_CONFIG row found for SYSNAME='${systemName}'`);
      }
    } catch (error) {
      console.error("Failed to fetch station info:", error);
    }
  };

  const handlePrint = async () => {
    try {
      const canvas = await html2canvas(receiptRef.current, {
        scale: thermalPrinterDetails?.SCALE || 4,
        width: thermalPrinterDetails?.WIDTH || 280,
        backgroundColor: "#fff",
        useCORS: true,
      });

      const base64 = canvas.toDataURL("image/png").split(",")[1];

      await axios.post("http://localhost:5442/api/print/silent", {
        fileBase64: base64,
        printerName: thermalPrinter,
      });
    } catch (err) {
      console.error("Print failed", err);
    }
  };

  useEffect(() => {
    fetchStationInfo();
  }, []);

  const addressProf =
    Object.keys(userDetails || {}).length > 0
      ? [
        userDetails?.add1,
        userDetails?.add2,
        userDetails?.add3,
        userDetails?.add4,
      ]
        .filter(Boolean)
        .join(", ")
      : "";

  const custInitial = (userDetails?.Custname || "?")
    .trim()
    .charAt(0)
    .toUpperCase();
  const paymentStatusLabel =
    totalNetAmount > 0 &&
      (cashAmt > 0 || cardAmt > 0 || upiAmt > 0 || onlineAmt > 0 || creditAmt > 0)
      ? "IN PROGRESS"
      : "NOT STARTED";
  const isTallied = totalNetAmount > 0 && paymentStatusLabel === "IN PROGRESS";

  const styles = {
    row: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    label: { fontSize: 12, color: "#64748b" },
    value: { fontSize: 13, fontWeight: 500, color: "#1e293b" },
  };

  const handleOpenPaymentModes = () => {
    smCodeRef.current?.focus();
    if (!barCodeData || barCodeData.length === 0) {
      messageApi.open({
        type: "error",
        content: (
          <span style={{ fontSize: "18px", fontWeight: 600 }}>
            Please add Design Details before selecting payment mode.
          </span>
        ),
      });
      return false;
    }
    setPayMode(true);
    return true;
  };

  const handleSaveInvoiceReturn = async () => {
    if (saving) return;
    smCodeRef.current?.focus();
    if (!barCodeData?.length) {
      messageApi.open({
        type: "error",
        content: (
          <span style={{ fontSize: "18px", fontWeight: 600 }}>
            Please add Design Details.
          </span>
        ),
      });
      return;
    }
    if (
      cashValue === "CREDIT" &&
      Object.keys(userDetails || {}).length === 0
    ) {
      messageApi.open({
        type: "error",
        content: (
          <span style={{ fontSize: "18px", fontWeight: 600 }}>
            Please enter customer details for CREDIT bill.
          </span>
        ),
      });
      return;
    }
    try {
      setSaving(true);
      if (billNo) {
        createReturnBillUpdate();
      } else {
        createReturnBillSave();
      }
      setBase64?.();
    } catch (error) {
      console.error("Error creating bill:", error);
      messageApi.open({
        type: "error",
        content: (
          <span style={{ fontSize: "18px", fontWeight: 600 }}>
            Something went wrong while creating the bill.
          </span>
        ),
      });
    } finally {
      setSaving(false);
    }
  };

  const handlePrintInvoiceReturn = async () => {
    if (printSaving) return;
    smCodeRef.current?.focus();
    if (!barCodeData?.length) {
      messageApi.open({
        type: "error",
        content: (
          <span style={{ fontSize: "18px", fontWeight: 600 }}>
            Please add Design Details.
          </span>
        ),
      });
      return;
    }
    if (
      cashValue === "CREDIT" &&
      Object.keys(userDetails || {}).length === 0
    ) {
      messageApi.open({
        type: "error",
        content: (
          <span style={{ fontSize: "18px", fontWeight: 600 }}>
            Please enter customer details for CREDIT bill.
          </span>
        ),
      });
      return;
    }
    try {
      setPrintSaving(true);
      invNoAPI();
      // handleBillPrint(nextInvNo);
      handlePrint();
      if (billNo) {
        createReturnBillUpdate();
      } else {
        createReturnBillSave();
      }
      setBase64?.();
    } catch (error) {
      console.error("Error creating bill:", error);
      messageApi.open({
        type: "error",
        content: (
          <span style={{ fontSize: "18px", fontWeight: 600 }}>
            Something went wrong while creating the bill.
          </span>
        ),
      });
    } finally {
      setPrintSaving(false);
    }
  };

  // Refs to always access latest state and handlers in global keydown listener
  const handleOpenPaymentModesRef = useRef(handleOpenPaymentModes);
  handleOpenPaymentModesRef.current = handleOpenPaymentModes;

  const handleSaveInvoiceReturnRef = useRef(handleSaveInvoiceReturn);
  handleSaveInvoiceReturnRef.current = handleSaveInvoiceReturn;

  const handlePrintInvoiceReturnRef = useRef(handlePrintInvoiceReturn);
  handlePrintInvoiceReturnRef.current = handlePrintInvoiceReturn;

  const openNewCustomerRef = useRef(openNewCustomer);
  openNewCustomerRef.current = openNewCustomer;

  const setCustomerSelectOpenRef = useRef(setCustomerSelectOpen);
  setCustomerSelectOpenRef.current = setCustomerSelectOpen;

  const modalsStateRef = useRef({ open, customerSelectOpen, payMode });
  modalsStateRef.current = { open, customerSelectOpen, payMode };

  useEffect(() => {
    const handleGlobalShortcuts = (e) => {
      if (e.key === "F9" && !e.ctrlKey && !e.altKey && !e.metaKey) {
        e.preventDefault();
        e.stopPropagation();
        if (modalsStateRef.current.open || modalsStateRef.current.customerSelectOpen) {
          return;
        }
        handleOpenPaymentModesRef.current?.();
        return;
      }

      if (e.key === "F10" && !e.ctrlKey && !e.altKey && !e.metaKey) {
        e.preventDefault();
        e.stopPropagation();
        if (modalsStateRef.current.open || modalsStateRef.current.customerSelectOpen) {
          return;
        }
        if (modalsStateRef.current.payMode) {
          setPayMode(false);
        }
        handlePrintInvoiceReturnRef.current?.();
        return;
      }

      const isAltOnly = e.altKey && !e.ctrlKey && !e.metaKey;
      if (!isAltOnly) return;

      const keyLower = (e.key || "").toLowerCase();

      if (keyLower === "s" || e.code === "KeyS") {
        e.preventDefault();
        e.stopPropagation();
        if (modalsStateRef.current.open || modalsStateRef.current.customerSelectOpen) {
          return;
        }
        if (modalsStateRef.current.payMode) {
          setPayMode(false);
        }
        handleSaveInvoiceReturnRef.current?.();
        return;
      }

      if (keyLower === "b" || e.code === "KeyB") {
        e.preventDefault();
        e.stopPropagation();
        if (modalsStateRef.current.open) {
          setOpen(false);
        }
        if (modalsStateRef.current.payMode) {
          setPayMode(false);
        }
        setCustomerSelectOpenRef.current?.(true);
        return;
      }

      if (keyLower === "c" || e.code === "KeyC") {
        e.preventDefault();
        e.stopPropagation();
        if (modalsStateRef.current.customerSelectOpen) {
          setCustomerSelectOpenRef.current?.(false);
        }
        if (modalsStateRef.current.payMode) {
          setPayMode(false);
        }
        openNewCustomerRef.current?.();
        return;
      }
    };

    window.addEventListener("keydown", handleGlobalShortcuts);
    return () => {
      window.removeEventListener("keydown", handleGlobalShortcuts);
    };
  }, []);

  return (
    <Spin spinning={loading} tip="Loading...">
      {contextHolder}
      <div ref={qrRef} style={{ display: "none" }}>
        <QRCodeCanvas value={upiLink} size={200} includeMargin={true} />
      </div>
      <div
        style={{
          padding: "5px",
          display: "flex",
          flexDirection: "column",
          height: "88vh",
          overflow: "hidden",
        }}
      >
        <div style={{ display: "flex", flex: 1, gap: 10, minHeight: 0 }}>
          {/* ================= LEFT COLUMN ================= */}
          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* ===== Header card ===== */}
            <Row
              gutter={[16, 16]}
              align="middle"
              wrap={false}
              style={{ flexWrap: "nowrap" }}
            >
              <Card
                bordered
                className="custometagnocard tax-card-in"
                style={{
                  position: "relative",
                  background:
                    "linear-gradient(145deg,#ffffff 0%,#f7f9fc 60%,#eef1f6 100%)",
                  borderRadius: "12px",
                  width: "100%",
                  padding: "0",
                  boxShadow: "0 3px 16px rgba(0,0,0,0.08)",
                  border: "1px solid #e2e6ec",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "stretch",
                    gap: 0,
                    width: "100%",
                    padding: "8px 10px 6px",
                  }}
                >
                  {/* COL 1 — Inv No + Customer Type */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                      flex: "0 0 250px",
                      justifyContent: "center",
                      background:
                        "linear-gradient(160deg, #f7e7dc 0%, #f3c7a6 55%, #e09e71 100%)",
                      borderRadius: "12px",
                      padding: "8px",
                      border: "1px solid rgba(224, 138, 79, 0.3)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      aria-hidden="true"
                      style={{
                        position: "absolute",
                        top: -20,
                        right: -20,
                        width: 70,
                        height: 70,
                        borderRadius: "50%",
                        background: "rgba(255,255,255,0.18)",
                        pointerEvents: "none",
                      }}
                    />
                    <div
                      className="tax-inv-badge"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                        borderRadius: "10px",
                        background:
                          "linear-gradient(135deg,rgba(255,244,235,0.97) 0%,rgba(255,225,203,0.97) 100%)",
                        padding: "8px 12px",
                        color: "#9a4212",
                        border: "1px solid rgba(224,138,79,0.28)",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        aria-hidden="true"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "38%",
                          height: "100%",
                          background:
                            "linear-gradient(105deg,transparent 40%,rgba(255,255,255,0.40) 50%,transparent 60%)",
                          pointerEvents: "none",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          lineHeight: 1.2,
                        }}
                      >
                        <h2
                          style={{
                            fontSize: "0.75rem",
                            margin: 0,
                            whiteSpace: "nowrap",
                            fontWeight: 600,
                            letterSpacing: "0.6px",
                            textTransform: "uppercase",
                            opacity: 0.72,
                          }}
                        >
                          Return No
                        </h2>
                        <span
                          style={{
                            fontSize: 22,
                            fontWeight: "bold",
                            letterSpacing: "-0.5px",
                          }}
                        >
                          {billNo ? billNo : invNo}
                        </span>
                        <span
                          style={{
                            fontSize: 10,
                            fontWeight: 600,
                            color: "#b45309",
                            display: "flex",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <CalendarOutlined style={{ fontSize: 10 }} />{" "}
                          {dayjs().format("DD-MMM-YYYY")}
                        </span>
                      </div>

                      <Button
                        icon={<FolderAddOutlined />}
                        shape="circle"
                        style={{
                          fontSize: 18,
                          background: "rgba(224,138,79,0.14)",
                          border: "1px solid rgba(224,138,79,0.28)",
                          color: "#b45309",
                        }}
                        onClick={() => {
                          setVisibleHis(true);
                          smCodeRef.current?.focus();
                        }}
                      />
                      <Button
                        icon={
                          <ReloadOutlined
                            style={{
                              color: "#d97706",
                              fontSize: "15px",
                              transition: "transform 1s ease-in-out",
                              transform: rotating
                                ? "rotate(360deg)"
                                : "rotate(0deg)",
                            }}
                          />
                        }
                        shape="circle"
                        onClick={handleReset}
                        style={{
                          flexShrink: 0,
                          background: "rgba(251,191,36,0.14)",
                          border: "1px solid rgba(251,191,36,0.28)",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "0.70rem",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        ▶ Customer Type
                      </span>
                      <Select
                        ref={jewelRef}
                        value={
                          selectJewelType
                            ? selectJewelType
                            : custTypeData[0]?.CUSTTYPE || null
                        }
                        onChange={(value) => {
                          setSelectJewelType(value);
                          setTimeout(() => tagNoRef?.current?.focus(), 0);
                        }}
                        style={{ width: "100%" }}
                      >
                        {custTypeData.map((jewel, index) => (
                          <Option key={index} value={jewel.CUSTTYPE}>
                            {jewel.CUSTTYPE}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>

                  <div
                    style={{
                      width: "1px",
                      background:
                        "linear-gradient(to bottom,transparent,#cbd5e1 25%,#cbd5e1 75%,transparent)",
                      margin: "0 12px",
                      flexShrink: 0,
                    }}
                  />

                  {/* COL 2 — Bill No / SM Code / Design Code */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 7,
                      flex: "0 0 23%",
                      justifyContent: "center",
                      background:
                        "linear-gradient(160deg,#fdfeff 0%,#f5f8fc 100%)",
                      borderRadius: "12px",
                      padding: "8px 10px",
                      border: "1px solid rgba(148,163,184,0.16)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      aria-hidden="true"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: -14,
                        width: 28,
                        height: 28,
                        transform: "translateY(-50%) rotate(45deg)",
                        background: "rgba(59,130,246,0.06)",
                        borderRadius: "3px",
                        pointerEvents: "none",
                      }}
                    />

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        paddingLeft: 6,
                      }}
                    >
                      <span
                        style={{
                          width: 100,
                          fontSize: "0.73rem",
                          fontWeight: 600,
                          color: "#7c3aed",
                          flexShrink: 0,
                        }}
                      >
                        ▶ Bill No
                      </span>
                      <Input
                        ref={estNoRef}
                        value={estNo}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[a-zA-Z]/g, "");
                          if (value.length <= 10) setEstNo(value);
                        }}
                        onKeyDown={handleEstNoKeyDown}
                        style={{
                          flex: 1,
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      />
                      <Button
                        type="primary"
                        ref={fetchRef}
                        onClick={() => {
                          smCodeRef.current?.focus();
                          modifySalesDetAPI(estNo);
                          modifySaleBillOpeningLedgerAPI(estNo);
                          modifySaleBillOnlineAPI(estNo);
                          modifySalesMastAPI(estNo);
                          setEstNo();
                        }}
                        style={{
                          background: "linear-gradient(135deg,#7c3aed,#6d28d9)",
                          border: "none",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "12px",
                          padding: "0 10px",
                        }}
                      >
                        Go
                      </Button>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        paddingLeft: 6,
                      }}
                    >
                      <span
                        style={{
                          width: 100,
                          fontSize: "0.73rem",
                          fontWeight: 600,
                          color: "#4b5563",
                          flexShrink: 0,
                        }}
                      >
                        ▶ SM Code
                      </span>
                      <Input
                        ref={smCodeRef}
                        autoFocus
                        value={smCode}
                        onChange={(e) => setSmCode(e.target.value)}
                        onKeyDown={handleSmCodeKeyDown}
                        style={{
                          flex: 1,
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      />
                      <Button
                        type="primary"
                        ref={smSubmitRef}
                        onClick={() => {
                          tagNoRef?.current?.focus();
                          if (smCode) smCodeAPI();
                        }}
                        style={{
                          background: "linear-gradient(135deg,#16a34a,#15803d)",
                          border: "none",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "12px",
                          padding: "0 10px",
                        }}
                      >
                        Go
                      </Button>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        paddingLeft: 6,
                      }}
                    >
                      <span
                        style={{
                          width: 100,
                          fontSize: "0.73rem",
                          fontWeight: 600,
                          color: "#A72703",
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                        }}
                      >
                        <TagOutlined style={{ fontSize: 11 }} /> Design Code
                      </span>
                      <Input
                        ref={tagNoRef}
                        onKeyDown={handleTagNoKeyDown}
                        value={tagNo}
                        onChange={(e) => setTagNo(e.target.value)}
                        style={{
                          flex: 1,
                          fontWeight: "bold",
                          textAlign: "center",
                          background: "linear-gradient(135deg,#fff5f5,#fdf0ef)",
                          border: "1.5px solid #e5a09e",
                          color: "#c0392b",
                          fontSize: "15px",
                          borderRadius: "6px",
                        }}
                      />
                      <Button
                        type="primary"
                        ref={submitRef}
                        onClick={async () => {
                          if (
                            (tagNo === "0" || !tagNo) &&
                            barCodeData?.length > 0
                          ) {
                            mobileRef.current?.focus();
                            setTagNo("");
                          } else {
                            await mainAPI();
                            await homeBillData();
                          }
                        }}
                        style={{
                          background: "linear-gradient(135deg,#c0392b,#a93226)",
                          border: "none",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "12px",
                          padding: "0 10px",
                        }}
                      >
                        Go
                      </Button>
                    </div>
                  </div>

                  <div
                    style={{
                      width: "1px",
                      background:
                        "linear-gradient(to bottom,transparent,#cbd5e1 25%,#cbd5e1 75%,transparent)",
                      margin: "0 12px",
                      flexShrink: 0,
                    }}
                  />

                  {/* COL 3 — Mobile No + item mini info */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 6,
                      width: "22%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        paddingLeft: 6,
                      }}
                    >
                      <span
                        style={{
                          width: 72,
                          fontSize: "0.72rem",
                          fontWeight: 600,
                          color: "#4b5563",
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        <PhoneOutlined style={{ fontSize: 13 }} /> Mobile No
                      </span>
                      <Input
                        ref={mobileRef}
                        onKeyDown={handleMobileNoKeyDown}
                        value={phoneNo}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[a-zA-Z]/g, "");
                          if (value.length <= 10) setPhoneNo(value);
                        }}
                        style={{
                          flex: 1,
                          fontWeight: "bold",
                          textAlign: "center",
                          color: "#374151",
                          fontSize: "13px",
                          borderColor: "#d1d5db",
                        }}
                      />
                      <Button
                        type="primary"
                        ref={searchRef}
                        onClick={() => {
                          if (/^\d{10}$/.test(phoneNo)) userDetailsAPI();
                        }}
                        style={{
                          background: "linear-gradient(135deg,#475569,#334155)",
                          border: "none",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "12px",
                          padding: "0 10px",
                        }}
                      >
                        Go
                      </Button>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: 7,
                        justifyContent: "center",
                        background:
                          "linear-gradient(160deg,#f8fafc 0%,#f0f3f8 100%)",
                        borderRadius: "12px",
                        padding: "8px 10px",
                        border: "1px solid rgba(148,163,184,0.16)",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        aria-hidden="true"
                        style={{
                          position: "absolute",
                          bottom: -6,
                          right: -6,
                          width: 0,
                          height: 0,
                          borderLeft: "24px solid transparent",
                          borderBottom: "24px solid rgba(59,130,246,0.07)",
                          pointerEvents: "none",
                        }}
                      />
                      {[
                        {
                          label: "Available",
                          icon: <MoneyCollectOutlined />,
                          topBar: "rgba(34,197,94,0.45)",
                          bg: "rgba(240,253,244,0.95)",
                          border: "rgba(134,239,172,0.50)",
                          iconBg: "rgba(220,252,231,1)",
                          iconColor: "#15803d",
                          value: barCodeData[0]?.Qty ?? "-",
                        },
                        {
                          label: "Balance",
                          icon: <TagOutlined />,
                          topBar: "rgba(59,130,246,0.45)",
                          bg: "rgba(247,250,255,0.95)",
                          border: "rgba(191,219,254,0.55)",
                          iconBg: "rgba(219,234,254,1)",
                          iconColor: "#1d4ed8",
                          value: barCodeData[0]?.Prodsize ?? "-",
                        },
                        {
                          label: "Purchase",
                          icon: <OrderedListOutlined />,
                          topBar: "rgba(245,158,11,0.50)",
                          bg: "rgba(255,252,245,0.95)",
                          border: "rgba(253,230,138,0.60)",
                          iconBg: "rgba(254,243,199,1)",
                          iconColor: "#b45309",
                          value: barCodeData[0]?.COLOUR ?? "-",
                        },
                      ].map(
                        ({
                          label,
                          icon,
                          topBar,
                          bg,
                          border,
                          iconBg,
                          iconColor,
                          value,
                        }) => (
                          <div
                            key={label}
                            style={{
                              height: "64px",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: 4,
                              marginTop: 22,
                              padding: "6px 8px",
                              borderRadius: 10,
                              border: `1px solid ${border}`,
                              background: bg,
                              flexDirection: "column",
                              position: "relative",
                              flex: 1,
                            }}
                          >
                            <div
                              aria-hidden="true"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                height: "2.5px",
                                background: topBar,
                                borderRadius: "10px 10px 0 0",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "-18px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: 28,
                                height: 28,
                                borderRadius: "50%",
                                background: iconBg,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: iconColor,
                                fontSize: 12,
                                boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                              }}
                            >
                              {icon}
                            </div>
                            <span
                              style={{
                                fontSize: "0.62rem",
                                color: "#6b7280",
                                flexShrink: 0,
                                textAlign: "center",
                                fontWeight: 500,
                                letterSpacing: "0.2px",
                              }}
                            >
                              {label}
                            </span>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 700,
                                color: "rgba(0,0,0,0.72)",
                              }}
                            >
                              {value}
                            </span>
                          </div>
                        ),
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      width: "1px",
                      background:
                        "linear-gradient(to bottom,transparent,#cbd5e1 25%,#cbd5e1 75%,transparent)",
                      margin: "0 12px",
                      flexShrink: 0,
                    }}
                  />

                  {/* COL 4 — Customer card */}
                  <div
                    style={{
                      flex: 1,
                      minWidth: 0,
                      display: "flex",
                      alignItems: "stretch",
                    }}
                  >
                    {!userDetails?.Custname ? (
                      <div
                        className="tax-customer-empty"
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 8,
                          padding: "10px 14px",
                          background:
                            "linear-gradient(135deg,#fafbff 0%,#f3f5fd 100%)",
                          borderRadius: "12px",
                          border: "1.5px dashed #bfdbfe",
                          cursor: "default",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg,#eff6ff,#dbeafe)",
                            border: "1.5px solid #bfdbfe",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <UserOutlined
                            style={{ fontSize: 16, color: "#60a5fa" }}
                          />
                        </div>

                        <span
                          style={{
                            fontSize: "0.66rem",
                            color: "rgb(140,143,148)",
                            textAlign: "center",
                            lineHeight: 1.5,
                            letterSpacing: "0.2px",
                          }}
                        >
                          No customer selected.
                        </span>

                        <div style={{ display: "flex", gap: 6, width: "100%" }}>
                          <button
                            className="sb-btn sb-btn-sm sb-browse"
                            onClick={() => {
                              setCustomerSelectOpen(true);
                            }}
                            title="Browse Customers (Alt+B)"
                          >
                            <span className="sb-badge sb-badge-sm">
                              <SearchOutlined style={{ fontSize: 11 }} />
                            </span>
                            Browse (Alt+B)
                          </button>

                          <button
                            className="sb-btn sb-btn-sm sb-create"
                            onClick={() => {
                              openNewCustomer();
                              smCodeRef.current?.focus();
                            }}
                            title="Create Customer (Alt+C)"
                          >
                            <span className="sb-badge sb-badge-sm">
                              <PlusOutlined style={{ fontSize: 11 }} />
                            </span>
                            Create (Alt+C)
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="tax-customer-card"
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          background: "#ffffff",
                          borderRadius: "12px",
                          border: "1px solid #e2e8f0",
                          overflow: "hidden",
                          boxShadow:
                            "0 1px 3px rgba(0,0,0,0.06), 0 3px 10px rgba(15,23,42,0.05)",
                          minWidth: 0,
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(120deg,#1e293b 0%,#334155 100%)",
                            padding: "7px 10px",
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: "9px",
                              background: "rgba(255,255,255,0.14)",
                              border: "1px solid rgba(255,255,255,0.20)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#fff",
                              fontWeight: 700,
                              fontSize: 13,
                              flexShrink: 0,
                            }}
                          >
                            {custInitial}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <Tooltip title={userDetails?.Custname}>
                              <div
                                style={{
                                  fontSize: "0.79rem",
                                  fontWeight: 700,
                                  color: "#fff",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {userDetails?.Custname?.length > 20
                                  ? `${userDetails.Custname.slice(0, 20)}...`
                                  : userDetails?.Custname}
                              </div>
                            </Tooltip>
                            <div
                              style={{
                                fontSize: "0.61rem",
                                color: "rgba(255,255,255,0.60)",
                                marginTop: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                              }}
                            >
                              {userDetails?.Area && (
                                <span>{userDetails.Area}</span>
                              )}
                              {userDetails?.Area && userDetails?.Mobileno && (
                                <span style={{ opacity: 0.5 }}>·</span>
                              )}
                              {userDetails?.Mobileno && (
                                <span
                                  style={{
                                    fontWeight: 600,
                                    color: "rgba(255,255,255,0.85)",
                                    fontFamily: "monospace",
                                  }}
                                >
                                  {userDetails.Mobileno}
                                </span>
                              )}
                            </div>
                          </div>
                          <div
                            style={{ display: "flex", gap: 4, flexShrink: 0 }}
                          >
                            <Tooltip title="Browse Customers (Alt+B)">
                              <button
                                onClick={() => {
                                  setCustomerSelectOpen(true);
                                }}
                                style={{
                                  width: 23,
                                  height: 23,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "rgba(148,163,184,0.20)",
                                  border: "1px solid rgba(203,213,225,0.36)",
                                  borderRadius: 5,
                                  color: "#e2e8f0",
                                  cursor: "pointer",
                                  fontSize: 11,
                                }}
                              >
                                <SearchOutlined />
                              </button>
                            </Tooltip>
                            <Tooltip title="QR Code">
                              <button
                                onClick={handleQrcodeOpen}
                                style={{
                                  width: 23,
                                  height: 23,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "rgba(59,130,246,0.16)",
                                  border: "1px solid rgba(147,197,253,0.32)",
                                  borderRadius: 5,
                                  color: "#93c5fd",
                                  cursor: "pointer",
                                  fontSize: 11,
                                }}
                              >
                                <QrcodeOutlined />
                              </button>
                            </Tooltip>
                            <Tooltip title="New Customer (Alt+C)">
                              <button
                                onClick={() => {
                                  openNewCustomer();
                                  smCodeRef.current?.focus();
                                }}
                                style={{
                                  width: 23,
                                  height: 23,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "rgba(34,197,94,0.16)",
                                  border: "1px solid rgba(134,239,172,0.32)",
                                  borderRadius: 5,
                                  color: "#86efac",
                                  cursor: "pointer",
                                  fontSize: 10,
                                }}
                              >
                                <PlusOutlined />
                              </button>
                            </Tooltip>
                          </div>
                        </div>

                        <div
                          style={{
                            padding: "6px 10px 7px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                          }}
                        >
                          {addressProf && (
                            <Tooltip title={addressProf}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 4,
                                  overflow: "hidden",
                                }}
                              >
                                <EnvironmentOutlined
                                  style={{
                                    fontSize: 9,
                                    color: "#94a3b8",
                                    flexShrink: 0,
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6b7280",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {addressProf}
                                </span>
                              </div>
                            </Tooltip>
                          )}
                          <div style={{ display: "flex", gap: 4 }}>
                            {[
                              {
                                label: "GST",
                                value: userDetails?.TINNO,
                                color: "#b45309",
                                bg: "#fffbeb",
                                border: "#fef3c7",
                              },
                              {
                                label: "STATE",
                                value: userDetails?.STATE,
                                color: "#1d4ed8",
                                bg: "#eff6ff",
                                border: "#dbeafe",
                              },
                              {
                                label: "STATION",
                                value: userDetails?.STATION,
                                color: "#475569",
                                bg: "#f1f5f9",
                                border: "#e2e8f0",
                              },
                            ].map((item) => (
                              <div
                                key={item.label}
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                  display: "flex",
                                  flexDirection: "column",
                                  padding: "2px 5px",
                                  background: item.value ? item.bg : "#fafafa",
                                  border: `1px solid ${item.value ? item.border : "#f1f1f1"}`,
                                  borderRadius: "5px",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "0.52rem",
                                    fontWeight: 700,
                                    color: "#9ca3af",
                                    letterSpacing: "0.2px",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {item.label}
                                </span>
                                <span
                                  style={{
                                    fontSize: "0.62rem",
                                    fontFamily: "monospace",
                                    fontWeight: 700,
                                    color: item.value ? item.color : "#cbd5e1",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.value || "—"}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Card>
            </Row>

            {/* ===== Table ===== */}
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div
                  className="tax-card-in"
                  style={{
                    marginTop: 3,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <DashboardTableHeaderStyles saleCode={2}>
                      <Table
                        columns={columns}
                        dataSource={barCodeData}
                        pagination={false}
                        size="small"
                        rowKey={(_, index) => index}
                        scroll={{ y: 280 }}
                      />
                    </DashboardTableHeaderStyles>
                  </div>
                </div>
              </Col>
            </Row>

            {/* ===== Footer ===== */}
            <Row
              gutter={[8, 0]}
              style={{
                flexShrink: 0,
                width: "100%",
                background: "linear-gradient(180deg,#f8fafc 0%,#ffffff 100%)",
                padding: "6px 8px",
                borderTop: "1px solid #dde3ec",
                boxShadow: "0 -3px 20px rgba(0,0,0,0.09)",
                borderRadius: "10px 10px 0 0",
                alignItems: "stretch",
                marginTop: "auto",
              }}
            >
              {/* Payment Mode */}
              <Col span={7} style={{ paddingRight: "4px", display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      width: "70px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      type="primary"
                      style={{
                        height: "140px",
                        width: "100%",
                        fontWeight: "600",
                        whiteSpace: "normal",
                        background:
                          "linear-gradient(160deg, #f5b98a 0%, #e08a4f 65%, #c96a2e 100%)",
                        border: "none",
                        color: "#ffffff",
                        flexDirection: "column",
                        borderRadius: "12px",
                        fontSize: "13px",
                        boxShadow: "0 4px 14px rgba(224,138,79,0.40)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={handleOpenPaymentModes}
                      title="Payment Mode (F9)"
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          color: "#c96a2e",
                          borderRadius: "50%",
                          backgroundColor: "rgba(255,255,255,0.92)",
                          padding: "10px",
                          marginBottom: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 40,
                          height: 40,
                          boxShadow: "0 2px 8px rgba(201,106,46,0.35)",
                        }}
                      >
                        <CreditCardOutlined />
                      </span>
                      Payment Mode (F9)
                    </Button>
                  </div>

                  <div
                    style={{
                      flex: 1,
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "0.8rem",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(90deg, rgb(158 170 189), rgb(177 191 215))",
                            color: "rgb(27 27 27)",
                          }}
                        >
                          <th
                            style={{
                              textAlign: "left",
                              padding: "8px 10px",
                              fontSize: "0.7rem",
                              borderBottom: "1px solid #ddd",
                            }}
                          >
                            Pay Mode
                          </th>
                          <th
                            style={{
                              textAlign: "right",
                              padding: "8px 10px",
                              fontSize: "0.7rem",
                              borderBottom: "1px solid #ddd",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              padding: "6px 10px",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            Cash
                          </td>
                          <td
                            style={{
                              padding: "6px 10px",
                              borderBottom: "1px solid #eee",
                              textAlign: "right",
                            }}
                          >
                            {Math.round(cashAmt || 0)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: "6px 10px",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            UPI / Online
                          </td>
                          <td
                            style={{
                              padding: "6px 10px",
                              borderBottom: "1px solid #eee",
                              textAlign: "right",
                            }}
                          >
                            {Number(upiAmt) > 0
                              ? Math.round(upiAmt || 0)
                              : Math.round(onlineAmt || 0)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: "6px 10px",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            Card
                          </td>
                          <td
                            style={{
                              padding: "6px 10px",
                              borderBottom: "1px solid #eee",
                              textAlign: "right",
                            }}
                          >
                            {Math.round(cardAmt || 0)}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              padding: "6px 10px",
                              borderTop: "2px solid #cbd5e1",
                              backgroundColor: "#f8fafc",
                              fontSize: "0.7rem",
                              fontWeight: 700,
                              color:
                                Number(creditAmt) > 0 ? "#b91c1c" : "#15803d",
                              textTransform: "uppercase",
                            }}
                          >
                            Credit Due
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              padding: "6px 10px",
                              borderTop: "2px solid #cbd5e1",
                              backgroundColor: "#f8fafc",
                              fontSize: "0.75rem",
                              fontWeight: 800,
                              fontFamily: "monospace",
                              color:
                                Number(creditAmt) > 0 ? "#b91c1c" : "#15803d",
                            }}
                          >
                            {Number(creditAmt || 0).toFixed(0)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </Col>

              {/* Ledger Summary */}
              {/* Ledger Summary */}
              <Col span={5}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    height: "100%",
                  }}
                >
                  {/* Total Return Qty row (moved here from sidebar) */}
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg,#f87171 0%,#b91c1c 100%)",
                      borderRadius: "8px",
                      padding: "7px 10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      color: "#fff",
                      boxShadow: "0 2px 8px rgba(185,28,28,0.35)",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "0.65rem",
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      ↩️ Total Return Qty
                    </span>
                    <span style={{ fontSize: "18px", fontWeight: 800 }}>
                      {totalQty}
                    </span>
                  </div>

                  <div
                    style={{
                      background:
                        "linear-gradient(150deg, rgba(241,245,255,0.95) 0%, rgba(236,242,254,0.97) 100%)",
                      borderRadius: "8px",
                      padding: "8px 10px",
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                      color: "#374151",
                      border: "1px solid rgba(148,163,184,0.45)",
                      boxShadow: "0 1px 6px rgba(71,85,105,0.08)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "0.62rem",
                        fontWeight: 700,
                        color: "#475569",
                        borderLeft: "2px solid rgba(100,116,139,0.50)",
                        paddingLeft: "6px",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <BankOutlined /> Ledger Summary
                    </div>
                    {[
                      {
                        label: "Prv. Balance",
                        value: Number(prvBalance)?.toFixed(0),
                      },
                      {
                        label: "Ledger Balance",
                        value: Number(creditAmt)?.toFixed(0),
                      },
                    ].map((item, i) => (
                      <div
                        key={i}
                        style={{
                          ...styles.row,
                          borderBottom: "0.5px solid #e2e8f0",
                          paddingBottom: 5,
                          paddingTop: 3,
                        }}
                      >
                        <span style={styles.label}>{item.label}</span>
                        <span style={styles.value}>{item.value}</span>
                      </div>
                    ))}
                    <div style={{ ...styles.row, paddingTop: 4 }}>
                      <span
                        style={{
                          ...styles.label,
                          fontWeight: 500,
                          color: "#1e293b",
                        }}
                      >
                        Total Balance
                      </span>
                      <span
                        style={{
                          fontSize: 15,
                          fontWeight: 500,
                          color: "#185FA5",
                          background: "#e6f1fb",
                          padding: "4px 12px",
                          borderRadius: 8,
                        }}
                      >
                        {Number(totalBalance)?.toFixed(0)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              {/* Payment Status */}
              <Col span={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px 14px",
                    height: "100%",
                    borderRadius: "10px",
                    border: isTallied
                      ? "1.5px solid rgba(134,239,172,0.70)"
                      : "1.5px solid rgba(252, 229, 165, 0.7)",
                    background: isTallied
                      ? "linear-gradient(150deg,rgba(240,253,244,0.95) 0%,rgba(220,252,231,0.90) 100%)"
                      : "linear-gradient(150deg,rgba(255,251,235,0.95) 0%,rgba(254,243,199,0.90) 100%)",
                    boxShadow: isTallied
                      ? "0 3px 14px rgba(22,163,74,0.15)"
                      : "0 3px 14px rgba(245,158,11,0.15)",
                    gap: "6px",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      fontSize: "0.58rem",
                      fontWeight: 700,
                      color: isTallied ? "#15803d" : "#b45309",
                      borderLeft: `2px solid ${isTallied ? "rgba(22,163,74,0.60)" : "rgba(245,158,11,0.60)"}`,
                      paddingLeft: "6px",
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                      alignSelf: "flex-start",
                      marginTop: "4px",
                    }}
                  >
                    Payment Status
                  </div>
                  <svg width="40" height="40" viewBox="0 0 42 42" fill="none">
                    <defs>
                      <linearGradient
                        id="sir-status-grad"
                        x1="0"
                        y1="0"
                        x2="1"
                        y2="1"
                      >
                        <stop
                          offset="0%"
                          stopColor={isTallied ? "#4ade80" : "#F8CD71"}
                        />
                        <stop
                          offset="100%"
                          stopColor={isTallied ? "#15803d" : "#F8CD71"}
                        />
                      </linearGradient>
                    </defs>
                    <circle
                      cx="21"
                      cy="21"
                      r="20"
                      fill="none"
                      stroke={
                        isTallied
                          ? "rgba(34,197,94,0.22)"
                          : "rgba(239,191,68,0.22)"
                      }
                      strokeWidth="1.5"
                    />
                    <circle
                      cx="21"
                      cy="21"
                      r="16"
                      fill="url(#sir-status-grad)"
                    />
                    <ellipse
                      cx="17.5"
                      cy="15"
                      rx="7"
                      ry="3.8"
                      fill="rgba(255,255,255,0.28)"
                    />
                    {isTallied ? (
                      <path
                        d="M12.5 21.5L18.5 27.5L29.5 15"
                        stroke="white"
                        strokeWidth="2.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    ) : (
                      <>
                        <circle
                          cx="21"
                          cy="21"
                          r="7"
                          fill="none"
                          stroke="white"
                          strokeWidth="2.2"
                        />
                        <path
                          d="M21 17V21L24 23"
                          stroke="white"
                          strokeWidth="2.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </>
                    )}
                  </svg>
                  <div
                    style={{
                      fontSize: "0.6rem",
                      fontWeight: 800,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      color: isTallied ? "#15803d" : "#b45309",
                      textAlign: "center",
                    }}
                  >
                    {paymentStatusLabel}
                  </div>
                </div>
              </Col>

              {/* Save / Print / PDF */}
              <Col
                span={4}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 6,
                }}
              >
                <Button
                  disabled={saving}
                  loading={saving}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    background:
                      "linear-gradient(135deg,#22c55e 0%,#15803d 100%)",
                    border: "none",
                    color: "white",
                    height: "40px",
                    fontSize: "14px",
                    borderRadius: "10px",
                    fontWeight: 700,
                    boxShadow: "0 3px 12px rgba(21,128,61,0.42)",
                  }}
                  onClick={handleSaveInvoiceReturn}
                  title="Save Return Invoice (Alt+S)"
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.25)",
                      fontSize: 12,
                    }}
                  >
                    <SaveOutlined />
                  </span>
                  {saving ? "Saving..." : billNo ? "UPDATE (Alt+S)" : "SAVE (Alt+S)"}
                </Button>
                <Button
                  disabled={printSaving}
                  loading={printSaving}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    background:
                      "linear-gradient(135deg,#fbbf24 0%,#d97706 100%)",
                    border: "none",
                    color: "white",
                    height: "40px",
                    fontSize: "14px",
                    borderRadius: "10px",
                    fontWeight: 700,
                    boxShadow: "0 3px 12px rgba(217,119,6,0.42)",
                  }}
                  onClick={handlePrintInvoiceReturn}
                  title="Print & Save Return Invoice (F10)"
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.25)",
                      fontSize: 12,
                    }}
                  >
                    <PrinterOutlined />
                  </span>
                  {printSaving ? "Printing..." : "PRINT (F10)"}
                </Button>
                <Button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    background:
                      "linear-gradient(135deg,#f87171 0%,#991b1b 100%)",
                    border: "none",
                    color: "white",
                    height: "40px",
                    fontSize: "14px",
                    borderRadius: "10px",
                    fontWeight: 700,
                    boxShadow: "0 3px 12px rgba(153,27,27,0.42)",
                  }}
                  onClick={async () => {
                    smCodeRef.current?.focus();
                    if (!barCodeData?.length) {
                      messageApi.open({
                        type: "error",
                        content: (
                          <span style={{ fontSize: "18px", fontWeight: 600 }}>
                            Please add Design Details.
                          </span>
                        ),
                      });
                      return;
                    }
                    if (
                      cashValue === "CREDIT" &&
                      Object.keys(userDetails || {}).length === 0
                    ) {
                      messageApi.open({
                        type: "error",
                        content: (
                          <span style={{ fontSize: "18px", fontWeight: 600 }}>
                            Please enter customer details for CREDIT bill.
                          </span>
                        ),
                      });
                      return;
                    }
                    const nextInvNo = await invNoAPI();
                    handleInvoicePdfDownload(nextInvNo);
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.25)",
                      fontSize: 12,
                    }}
                  >
                    <FilePdfOutlined />
                  </span>
                  PDF
                </Button>
              </Col>

              {/* Amount Details */}
              <Col span={5}>
                <div
                  style={{
                    background:
                      "linear-gradient(150deg, rgba(241, 245, 255, 0.95) 0%, rgb(210 225 255 / 97%) 100%)",
                    borderRadius: "12px",
                    fontWeight: "bold",
                    padding: "10px 14px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    border: "1px solid rgba(148,163,184,0.5)",
                    boxShadow: "0 4px 14px rgba(71,85,105,0.12)",
                  }}
                >
                  <div
                    style={{
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      color: "#475569",
                      borderLeft: "3px solid #475569",
                      paddingLeft: "8px",
                      letterSpacing: "0.6px",
                      textTransform: "uppercase",
                    }}
                  >
                    Amount Details
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <label
                      style={{ flex: 1, fontSize: "0.75rem", color: "#475569" }}
                    >
                      Total Amount
                    </label>
                    <Input
                      disabled
                      value={Number(totalAmount).toFixed(0)}
                      style={{
                        width: 130,
                        fontWeight: "bold",
                        textAlign: "right",
                        backgroundColor: "rgba(248,250,252,0.95)",
                        color: "#334155",
                        border: "1.5px solid rgba(148,163,184,0.6)",
                        borderRadius: "6px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <label
                      style={{ flex: 1, fontSize: "0.75rem", color: "#475569" }}
                    >
                      Item Discount
                    </label>
                    <Input
                      disabled
                      value={Number(totalDiSAmt || 0).toFixed(0)}
                      style={{
                        width: 130,
                        fontWeight: "bold",
                        textAlign: "right",
                        backgroundColor: "rgba(248,250,252,0.95)",
                        color: "#334155",
                        border: "1.5px solid rgba(148,163,184,0.6)",
                        borderRadius: "6px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <label
                      style={{ flex: 1, fontSize: "0.75rem", color: "#475569" }}
                    >
                      Gross Amount
                    </label>
                    <Input
                      disabled
                      value={Number(totalGrossAmount).toFixed(0)}
                      style={{
                        width: 130,
                        fontWeight: "bold",
                        textAlign: "right",
                        backgroundColor: "rgba(248,250,252,0.95)",
                        color: "#334155",
                        border: "1.5px solid rgba(148,163,184,0.6)",
                        borderRadius: "6px",
                      }}
                    />
                  </div>
                  {adminType === "ADMIN" && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <label
                        style={{
                          flex: 1,
                          fontSize: "0.75rem",
                          color: "#475569",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        Discount
                        <Input
                          value={disPer}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!/^\d*$/.test(value)) return;
                            if (value.length > 3) return;
                            setDisPer(value);
                            const discountPer = totalGrossAmount * value;
                            const disAmt = discountPer / 100;
                            setTotalDiscountAmt(disAmt);
                            const netAmount = totalGrossAmount - disAmt;
                            setTotalNetAmount(netAmount);
                            setTotalAdjust(0);
                          }}
                          onFocus={(e) => e.target.select()}
                          style={{
                            width: 50,
                            textAlign: "right",
                            backgroundColor: "#AAC4F5",
                          }}
                        />
                        %
                      </label>
                      <Input
                        value={totalDiscountAmt}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            /^\d*\.?\d{0,2}$/.test(value) &&
                            value.length <= 15
                          ) {
                            setTotalDiscountAmt(value);
                            const netAmount = totalGrossAmount - value;
                            setTotalNetAmount(netAmount);
                            setTotalAdjust(0);
                          }
                        }}
                        onFocus={(e) => e.target.select()}
                        style={{
                          width: 130,
                          fontWeight: "bold",
                          textAlign: "right",
                          backgroundColor: "rgba(248,250,252,0.95)",
                          color: "#334155",
                          border: "1.5px solid rgba(148,163,184,0.6)",
                          borderRadius: "6px",
                        }}
                      />
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 6,
                      borderRadius: "10px",
                      background:
                        "linear-gradient(135deg,rgba(255,244,235,0.97) 0%,rgba(255,225,203,0.97) 100%)",
                      border: "1px solid rgba(224,138,79,0.28)",
                      padding: "8px 12px",
                    }}
                  >
                    <label
                      style={{
                        flex: 1,
                        fontSize: "13px",
                        fontWeight: 800,
                        color: "#9a4212",
                        letterSpacing: "0.4px",
                        textTransform: "uppercase",
                      }}
                    >
                      NET Amount
                    </label>
                    <span
                      style={{
                        fontSize: "24px",
                        fontWeight: 800,
                        color: "#9a4212",
                        letterSpacing: "-0.5px",
                      }}
                    >
                      {Number(totalNetAmount)?.toFixed(0)}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {/* ================= RIGHT SIDEBAR ================= */}
          <div
            style={{
              width: 210,
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              gap: 12,
              overflowY: "auto",
            }}
          >
            <style>{`
    @keyframes sb-glow {
      0%, 100% { box-shadow: 0 2px 10px var(--sb-glow-c, rgba(0,0,0,0.12)); }
      50%      { box-shadow: 0 6px 22px var(--sb-glow-c, rgba(0,0,0,0.12)); }
    }
    @keyframes sb-icon-bounce {
      0%, 100% { transform: translateY(0) rotate(0deg); }
      50%      { transform: translateY(-2px) rotate(-6deg); }
    }
    @keyframes sb-icon-spin {
      0%   { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    @keyframes sb-shine {
      0%   { transform: translateX(-120%) skewX(-20deg); }
      100% { transform: translateX(220%) skewX(-20deg); }
    }
    @keyframes sb-tile-icon-wiggle {
      0%, 80%, 100% { transform: rotate(0deg); }
      85%  { transform: rotate(-10deg); }
      92%  { transform: rotate(10deg); }
    }

    .sb-tile-icon { display: inline-block; animation: sb-tile-icon-wiggle 3.5s ease-in-out infinite; }
    .sb-tile:nth-child(1) .sb-tile-icon { animation-delay: 0.0s; }
    .sb-tile:nth-child(2) .sb-tile-icon { animation-delay: 0.15s; }
    .sb-tile:nth-child(3) .sb-tile-icon { animation-delay: 0.30s; }
    .sb-tile:nth-child(4) .sb-tile-icon { animation-delay: 0.45s; }
    .sb-tile:nth-child(5) .sb-tile-icon { animation-delay: 0.60s; }
    .sb-tile:nth-child(6) .sb-tile-icon { animation-delay: 0.75s; }
    .sb-tile-value { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block; max-width: 100%; }

    .sb-qty-card {
      position: relative;
      overflow: hidden;
      border-radius: 14px;
      padding: 14px 12px;
      text-align: center;
      background: linear-gradient(135deg,#f87171 0%,#b91c1c 100%);
      color: #fff;
      animation: sb-glow 2.4s ease-in-out infinite;
      --sb-glow-c: rgba(185,28,28,0.45);
    }
    .sb-qty-card::after {
      content: "";
      position: absolute;
      top: 0; left: 0; width: 40%; height: 100%;
      background: linear-gradient(120deg, transparent, rgba(255,255,255,0.35), transparent);
      animation: sb-shine 2.8s ease-in-out infinite;
    }
    .sb-qty-icon {
      width: 34px; height: 34px; border-radius: 10px; margin: 0 auto 6px;
      background: rgba(255,255,255,0.22);
      display: flex; align-items: center; justify-content: center;
      font-size: 17px;
    }
    .sb-qty-label { font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; opacity: 0.85; }
    .sb-qty-value { font-size: 26px; font-weight: 800; line-height: 1.15; }

    .sb-btn {
      position: relative;
      display: flex; align-items: center; gap: 10px;
      padding: 10px 12px; border: none; border-radius: 12px;
      cursor: pointer; text-align: left; color: #fff;
      font-weight: 700; font-size: 13px; letter-spacing: 0.2px;
      transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
      animation: sb-glow 2.6s ease-in-out infinite;
    }
    .sb-btn:hover { transform: translateY(-2px) scale(1.015); filter: brightness(1.06); }
    .sb-btn:active { transform: translateY(0) scale(0.99); }
    .sb-badge {
      flex-shrink: 0; width: 28px; height: 28px; border-radius: 9px;
      background: rgba(255,255,255,0.28);
      display: flex; align-items: center; justify-content: center; font-size: 15px;
      animation: sb-icon-bounce 1.8s ease-in-out infinite;
    }
    .sb-badge-spin { animation: sb-icon-spin 3s linear infinite; }
    .sb-chevron { margin-left: auto; opacity: 0.75; font-size: 12px; }

    .sb-info     { --sb-glow-c: rgba(56,189,248,0.45);  background: linear-gradient(135deg,#7dd3fc,#0284c7); }
    .sb-exchange { --sb-glow-c: rgba(211, 52, 131, 0.45);  background: linear-gradient(135deg, #e76ea0, #960549d7); }

    .sb-btn-sm { padding: 6px 10px; border-radius: 8px; font-size: 0.68rem; gap: 5px; justify-content: center; flex: 1; }
    .sb-badge-sm { width: 20px; height: 20px; border-radius: 6px; font-size: 11px; }
    .sb-browse { --sb-glow-c: rgba(209, 194, 185, 0.45); background: linear-gradient(135deg, #787a7ade, #928f8d); }
    .sb-create { --sb-glow-c: rgba(128, 160, 140, 0.45); background: linear-gradient(135deg, #6b69d6, #535480); }
  `}</style>

            {/* Item Details card */}
            <div
              style={{
                background: "linear-gradient(150deg, #fff1e8 0%, #fff7f2 100%)",
                borderRadius: "12px",
                padding: "12px 8px",
                border: "1px solid #f3ddc9",
                boxShadow: "0 2px 10px rgba(224,138,79,0.10)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: "0.66rem",
                  fontWeight: 800,
                  color: "#c96a2e",
                  marginBottom: "8px",
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#e08a4f",
                  }}
                />
                Item Details
              </div>

              <div
                style={{
                  textAlign: "center",
                  fontSize: "15px",
                  fontWeight: 800,
                  color: "#7c3410",
                  marginBottom: 10,
                }}
              >
                {barCodeData[0]?.DesignCode || "-"}
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {[
                  {
                    label: "Available",
                    value: barCodeData[0]?.Qty ?? "-",
                    icon: "📦",
                    tint: "#dcfce7",
                    color: "#15803d",
                  },
                  {
                    label: "Size",
                    value: barCodeData[0]?.Prodsize ?? "-",
                    icon: "📏",
                    tint: "#dbeafe",
                    color: "#1d4ed8",
                  },
                  {
                    label: "Color",
                    value: barCodeData[0]?.COLOUR ?? "-",
                    icon: "🎨",
                    tint: "#fef3c7",
                    color: "#b45309",
                  },
                  {
                    label: "HSN",
                    value: barCodeData[0]?.HSNCODE ?? "-",
                    icon: "🏷️",
                    tint: "#f1f5f9",
                    color: "#475569",
                  },
                  {
                    label: "Fashion",
                    value: barCodeData[0]?.FITTING ?? "-",
                    icon: "✨",
                    tint: "#ccfbf1",
                    color: "#0f766e",
                  },
                  {
                    label: "Offer",
                    value: barCodeData[0]?.SLEVES ?? "-",
                    icon: "🎁",
                    tint: "#f3e8ff",
                    color: "#7e22ce",
                  },
                ].map((row) => (
                  <div
                    key={row.label}
                    className="sb-tile"
                    title={String(row.value)}
                    style={{
                      background: row.tint,
                      borderRadius: "9px",
                      padding: "7px 10px",
                      minWidth: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 8,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                        color: row.color,
                        fontWeight: 700,
                        fontSize: "10.5px",
                        flexShrink: 0,
                      }}
                    >
                      <span className="sb-tile-icon">{row.icon}</span>
                      {row.label}
                    </div>
                    <span
                      className="sb-tile-value"
                      style={{
                        fontSize: "12.5px",
                        fontWeight: 700,
                        color: "#1e293b",
                        textAlign: "right",
                      }}
                    >
                      {row.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* QTY — highlighted stat card */}
            {/* <div className="sb-qty-card">
              <div className="sb-qty-icon">↩️</div>
              <div className="sb-qty-label">Total Return Qty</div>
              <div className="sb-qty-value">{totalQty}</div>
            </div> */}

            <button
              className="sb-btn sb-info"
              style={{ minHeight: 58, padding: "14px 12px" }}
              onClick={() => {
                setMobileOpen(true);
                smCodeRef.current?.focus();
              }}
            >
              <span className="sb-badge">ℹ️</span>
              Cust. Bill Info
              <span className="sb-chevron">›</span>
            </button>

            <button
              className="sb-btn sb-exchange"
              style={{ minHeight: 58, padding: "14px 12px" }}
              onClick={() => navigate("/exchange-bill")}
            >
              <span className="sb-badge sb-badge-spin">🔄</span>
              Exchange Bill
              <span className="sb-chevron">›</span>
            </button>
          </div>
        </div>
      </div>

      <EstimationSelectDialog
        visibleHis={visibleHis}
        setVisibleHis={setVisibleHis}
        modifyOnlineAPI={modifyBillOnlineAPI}
        modifyDetAPI={modifyDetAPI}
        modifyMastAPI={modifyMastAPI}
        modifyLedgerAPI={modifyBillOpeningLedgerAPI}
        setBillNo={setBillNo}
        setBillDate={setBillDate}
        handleReset={handleRestore}
        setSearchText={setSearchText}
        searchText={searchText}
        smCodeRef={smCodeRef}
        apiTableName="RETURN_MAST" // ADD
        extraWhere="" // ADD (no APPNO filter for returns)
      />
      <PaymentModesDialog
        billNo={billNo}
        invNo={invNo}
        payMode={payMode}
        setPayMode={setPayMode}
        totalNetAmount={totalNetAmount}
        cashValue={cashValue}
        setCashValue={setCashValue}
        cashAmt={cashAmt}
        setCashAmt={setCashAmt}
        cardAmt={cardAmt}
        setCardAmt={setCardAmt}
        upiAmt={upiAmt}
        setUpiAmt={setUpiAmt}
        onlineAmt={onlineAmt}
        setOnlineAmt={setOnlineAmt}
        creditAmt={creditAmt}
        setCreditAmt={setCreditAmt}
        userDetails={userDetails}
        cardAcc={cardAcc}
        upiAcc={upiAcc}
        onlineAcc={onlineAcc}
        setOpen={setOpen}
        base64QR={base64QR}
        cPhoneNo={cPhoneNo}
        setCPhoneNo={setCPhoneNo}
        userDetailsAPI={userDetailsAPI}
        smCodeRef={smCodeRef}
      />

      <CustomerDialog
        open={open}
        mode="new"
        onCancel={() => {
          setOpen(false);
          setFormValues({
            mobile1: "",
            city: "",
            name: "",
            mobile2: "",
            phone: "",
            address1: "",
            address2: "",
            address3: "",
            address4: "",
            state: "ANDHRA PRADESH",
            stateCode: "37",
            gstin: "",
            panNo: "",
            idProof: "",
            dob: "",
            anniversary: "",
            locationType: "LOCAL",
          });
          smCodeRef.current?.focus();
        }}
        onSave={createCustomerDetailsAPI}
        formValues={formValues}
        setFormValues={setFormValues}
        deleteCustomerDetailsAPI={deleteCustomerDetailsAPI}
        smCodeRef={smCodeRef}
        customerLookupAPI={async (mobile) => {
          try {
            const res = await axios.get(
              `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=MOBILENO='${mobile}'`,
              { headers: { tenantName } },
            );
            return res.data?.[0] ?? null;
          } catch {
            return null;
          }
        }}
      />
      <CustomerSelectDialog
        open={customerSelectOpen}
        source="CUSTOMER"
        custType="CUSTOMER"
        onCancel={() => {
          setCustomerSelectOpen(false);
          smCodeRef.current?.focus();
        }}
        onSelect={handleCustomerSelect}
        onAddCustomer={openNewCustomer}
      />
      <EditItemDetails
        itemDetailsOpen={itemDetailsOpen}
        setItemDetailsOpen={setItemDetailsOpen}
        setItemDetailsData={setItemDetailsData}
        itemDetailsData={itemDetailsData}
        itemDesignCode={itemDesignCode}
        setBarCodeData={setBarCodeData}
        barCodeData={barCodeData}
        qtyData={qtyData}
        smCodeRef={smCodeRef}
        adminType={adminType}
      />
      <HoldSelectDialog
        setHoldOpen={setHoldOpen}
        holdOpen={holdOpen}
        holdData={holdData}
        setHoldData={setHoldData}
        filteredHoldData={filteredHoldData}
        setFilteredHoldData={setFilteredHoldData}
        selectedHoldRowKeys={selectedHoldRowKeys}
        handleSearchHoldInput={handleSearchHoldInput}
        handleCheckboxChangeHold={handleCheckboxChangeHold}
        handleReset={handleRestore}
        setSearchHoldText={setSearchHoldText}
        searchHoldText={searchHoldText}
        filterDataByHoldNo={filterDataByHoldNo}
        setHNo={setHNo}
      />
      <HomeBillDialog
        homeDetailsOpen={homeDetailsOpen}
        setHomeDetailsOpen={setHomeDetailsOpen}
        qty={qty}
        setQty={setQty}
        amount={amount}
        setAmount={setAmount}
        disCount={disCount}
        setDisCount={setDisCount}
        rate={rate}
        setRate={setRate}
        disAmt={disAmt}
        setDisAmt={setDisAmt}
        productName={productName}
        setProductName={setProductName}
        designCode={designCode}
        setDesignCode={setDesignCode}
        setPTypeName={setPTypeName}
        setHsnCode={setHsnCode}
        productData={productData}
        setProductData={setProductData}
        setBrandName={setBrandName}
        handleHomeBillSave={handleHomeBillSave}
      />
      <CustomerBillInfoDialog
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        mobile={mobile}
        setMobile={setMobile}
        smCodeRef={smCodeRef}
      />
      <DirectPrint
        userDetails={userDetails}
        userPhone={userPhone}
        address={address}
        address1={address1}
        gstNo={gstNo}
        nextInvNo={invNo}
        billNo={billNo}
        billDate={billDate}
        userName={userName}
        barCodeData={barCodeData}
        totalAmount={totalAmount}
        totalDiSAmt={totalDiSAmt}
        totalNetAmount={totalNetAmount}
        totalQty={totalQty}
        base64Images={base64Images}
        base64QR={base64QR}
        totalGstData={totalGstData}
        ins={ins}
        ins1={ins1}
        ins2={ins2}
        ins3={ins3}
        ins4={ins4}
        ins5={ins5}
        ins6={ins6}
        gstValue={gstValue}
        cashAmt={cashAmt}
        cardAmt={cardAmt}
        onlineAmt={onlineAmt}
        upiAmt={upiAmt}
        creditAmt={creditAmt}
        handlePrint={handlePrint}
        receiptRef={receiptRef}
        ref={samplePrintRef}
      />
      <QrCodeDialog
        qrCodeOpen={qrCodeOpen}
        handleQrcodeCancel={handleQrcodeCancel}
        base64QR={base64QR}
      />
    </Spin>
  );
};

export default SalesInvoiceReturn;
